import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import { MdAdd, MdClose, MdChevronRight, MdChevronLeft } from "react-icons/md";
import { Button, Col, Row, Form, Card } from "react-bootstrap";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { ToastContainer, toast, Zoom } from "react-toastify";
import { motion, AnimatePresence } from 'framer-motion';
import { Stack, Typography, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { storage } from "../../firebase"; // Adjust path if needed
import { ref, getDownloadURL, deleteObject, uploadBytesResumable } from "firebase/storage";
//import { signInAnonymously } from 'firebase/auth';

import api from '../../api';
import "../css/edit/editdoc.css";
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from "../../context/authContext";
import { Datacontext } from "../../context/dataContext";
import { AddClient } from "../client/addcllient";
import { CopyMsg } from '../others/copy_msg';
import { MSGS } from '../others/msg';

// --- CUSTOM 3-STATE TOGGLE COMPONENT ---
const ThreeStateToggle = ({ value, onChange, disabled }) => {
  const getTranslate = () => {
    if (value === 'yes') return 'translateX(38px)';
    if (value === 'no') return 'translateX(2px)';
    return 'translateX(20px)';
  };

  const getBgColor = () => {
    if (value === 'yes') return '#ece917';
    if (value === 'no') return '#8a2be2';
    return '#d1d1d1';
  };

  const getIconColor = (type) => {
    if (value === null || value === "") return '#555';
    if (type === 'no') return value === 'no' ? '#ece917' : '#4a127e';
    if (type === 'yes') return value === 'yes' ? '#4a127e' : '#ece917';
  };

  const handleClick = (e) => {
    if (disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    if (x < 22) onChange('no');
    else if (x > 44) onChange('yes');
    else onChange(null);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'relative', width: '66px', height: '26px',
        backgroundColor: getBgColor(), borderRadius: '13px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 8px', cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1, transition: 'all 0.3s ease',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)', border: '1px solid rgba(0,0,0,0.1)'
      }}
    >
      <span style={{ color: getIconColor('no'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✕</span>
      <span style={{ color: getIconColor('yes'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✓</span>
      
      <div style={{
        position: 'absolute', top: '2px', left: '0', width: '20px', height: '20px', 
        backgroundColor: '#fff', borderRadius: '50%', 
        transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)', transform: getTranslate(), 
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}>
        <div style={{ width: '4px', height: '4px', backgroundColor: getBgColor(), borderRadius: '50%', transition: 'background-color 0.3s' }} />
      </div>
    </div>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28, height: 16, padding: 0, display: 'flex',
  '&:active': { '& .MuiSwitch-thumb': { width: 15 }, '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(9px)' } },
  '& .MuiSwitch-switchBase': { padding: 2, '&.Mui-checked': { transform: 'translateX(12px)', color: '#fff', '& + .MuiSwitch-track': { opacity: 1, backgroundColor: '#e7ac2d' } } },
  '& .MuiSwitch-thumb': { boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)', width: 12, height: 12, borderRadius: 6, transition: theme.transitions.create(['width'], { duration: 200 }) },
  '& .MuiSwitch-track': { borderRadius: 16 / 2, opacity: 1, backgroundColor: 'rgba(0,0,0,.25)', boxSizing: 'border-box' },
}));

const TitleCase = (str) => {
  return str ? str.toLowerCase().replace(/\s+/g, ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : "";
};

export const Editdoc = ({ set_docedit, id, onclose }) => {
    const { user } = useContext(AuthContext);
    const { documents, users, clients, docs, fetchDocs, fetchSLayout, fetchDocuments, fetchClients, sVillage, sOffice, sZone, sLayout, ecs } = useContext(Datacontext);
    const { setDim } = useContext(Dimcontext);
    const navigate = useNavigate();

    // Original Data Ref for delta checking
    const [originalData, setOriginalData] = useState(null);
    const [originalEditd, setOriginalEditd] = useState(null);

    // Modal & Loading States
    const [add, setAdd] = useState(false);
    const [msg, set_msg] = useState(false);
    const [activeMsgText, setActiveMsgText] = useState("");
    const [bt, setBt] = useState(false);
    
    // Stepper State
    const [currentStep, setCurrentStep] = useState(1);
    const [status, setStatus] = useState("offline");

    // Dropdown Data States
    const [options_edoc, set_options_edoc] = useState([]);
    const [eoption_User, set_eoptions_User] = useState([]);
    const [eoptions, set_eoptions] = useState([]);
    const [ooptions, set_ooptions] = useState([]);

    // Core Form States
    const [editonedoc, set_editonedoc] = useState({});
    const [eusers, set_eusers] = useState([]);
    const [up, set_Up] = useState([]); // Tracks modified keys for payload delta
    const [formData, setFormData] = useState({ zoneId: '', officeId: '', villageId: '', layoutId: '' });

    // Dynamic Party Details
    const [buyere_Details, set_Buyere_Details] = useState([{ buyer_Detail: {}, buyer_aadhar: "" }]);
    const [sellere_Details, set_Sellere_Details] = useState([{ seller_Detail: {}, seller_aadhar: "" }]);
    const [witnesse_Details, set_Witnesse_Details] = useState([{ witness_Detail: {}, witness_aadhar: "" }, { witness_Detail: {}, witness_aadhar: "" }]);
    const [parent_document, set_Parent_Document] = useState([{ type: "", number: "" }]);
    const [stamp_Paper, set_Stamp_Paper] = useState([{ value: "", number: "" }]);
    const [hasStampPaper, setHasStampPaper] = useState("yes");
    const [alreadyAppliedEc, setAlreadyAppliedEc] = useState("no");
    const [linkedEc, setLinkedEc] = useState(null);

    // Tracking Workflow Stage Values
    const [editd, set_Editd] = useState({
        value_check: { clicked: 0, values: null, doc_value: "" },
        draft_prepared: { clicked: 0, values: null },
        draft_send: { clicked: 0, values: null, through: '' },
        draft_approved: { clicked: 0, values: null, by: "" },
        certificate_applied: { clicked: 0, values: null, eca_no: "" },
        certificate_received: { clicked: 0, values: null },
        deed_no: { clicked: 0, values: null, tp_no: '' },
        token_initiated: { clicked: 0, values: null, token_no: "", time: "" },
        document_registered: { clicked: 0, values: null, document_no: "" },
        document_pending: { clicked: 1, values: "no", document_no: "" },
        document_collected: { clicked: 0, values: null },
        document_scanned: { clicked: 0, values: null },
        payment: { clicked: 0, values: null },
        other: { clicked: 0, values: null, cusDetail: null },
    });

    const DATA = { zones: sZone, offices: sOffice, villages: sVillage };
    const formOffices = useMemo(() => DATA.offices.filter(o => o.zoneId === formData.zoneId), [formData.zoneId, DATA.offices]);
    const formVillages = useMemo(() => DATA.villages.filter(v => v.officeId === formData.officeId), [formData.officeId, DATA.villages]);
    const formLayout = useMemo(() => sLayout.filter(v => v.villageId === formData.villageId), [formData.villageId, sLayout]);

    const showToast = (message) => toast.warn(message, { position: "bottom-center", theme: "dark", transition: Zoom });

    // --- INITIAL DATA LOAD ---
    useEffect(() => {
        const d = documents.find(item => item.id === id);
        if (d) {
            setOriginalData(d);
            set_editonedoc(d);
            setStatus(d.status || "offline");

            // Mapping Dropdowns
            set_eusers(d.managed_By?.map(m => ({ value: m, label: m?.toUpperCase() })) || []);
            setFormData({
                zoneId: sZone.find(v => String(v.zoneName).toLowerCase() === String(d.zone).toLowerCase())?.id || "",
                officeId: sOffice.find(v => String(v.officeName).toLowerCase() === String(d.register_office).toLowerCase())?.id || "",
                villageId: sVillage.find(v => String(v.villageName).toLowerCase() === String(d.village).toLowerCase())?.id || "",
                layoutId: sLayout.find(v => String(v.layoutName).toLowerCase() === String(d.layout_name).toLowerCase())?.id || ""
            });

            // Mapping Dynamic Arrays
            if (d.buyers?.length > 0) set_Buyere_Details(d.buyers);
            if (d.sellers?.length > 0) set_Sellere_Details(d.sellers);
            if (d.witness?.length > 0) set_Witnesse_Details(d.witness);
            if (d.parent_document?.length > 0) set_Parent_Document(d.parent_document);
            if (d.stamp_Paper?.length > 0) {
                set_Stamp_Paper(d.stamp_Paper);
                setHasStampPaper("yes");
            } else {
                set_Stamp_Paper([{ value: "", number: "" }]);
                setHasStampPaper("no");
            }

            const applied = d.already_applied_ec === "yes" ? "yes" : "no";
            setAlreadyAppliedEc(applied);
            if (applied === "yes" && d.linked_ec?.id) {
                const ownerName = d.linked_ec.owner_name || d.linked_ec.owner?.name || "N/A";
                setLinkedEc({
                    value: d.linked_ec.id,
                    label: `${(d.linked_ec.application_no || "N/A").toUpperCase()} — ${String(ownerName).toUpperCase()}`,
                    ec: {
                        id: d.linked_ec.id,
                        application_no: d.linked_ec.application_no || "",
                        owner: { name: ownerName },
                        register_office: d.linked_ec.register_office || "",
                        docstatus: d.linked_ec.docstatus || "",
                        ecno: d.linked_ec.ecno || null,
                    },
                });
            } else {
                setLinkedEc(null);
            }

            // Mapping 9-Stage Tracker Data
            const initialEditd = {
                value_check: { clicked: d.value_check?.clicked ?? 0, values: d.value_check?.values ?? null, doc_value: d.value_check?.doc_value ?? "" },
                draft_prepared: { clicked: d.draft_prepared?.clicked ?? 0, values: d.draft_prepared?.values ?? null },
                draft_send: { clicked: d.draft_send?.clicked ?? 0, values: d.draft_send?.values ?? null, through: d.draft_send?.through ?? "", file: null, fileData: d.draft_send?.fileData ?? null },
                draft_approved: { clicked: d.draft_approved?.clicked ?? 0, values: d.draft_approved?.values ?? null, by: d.draft_approved?.by ?? "" },
                certificate_applied: { clicked: d.certificate_applied?.clicked ?? 0, values: d.certificate_applied?.values ?? null, eca_no: d.certificate_applied?.eca_no ?? "" },
                certificate_received: { clicked: d.certificate_received?.clicked ?? 0, values: d.certificate_received?.values ?? null, file: null, fileData: d.certificate_received?.fileData ?? null },
                deed_no: { clicked: d.deed_no?.clicked ?? 0, values: d.deed_no?.values ?? null, tp_no: d.deed_no?.tp_no ?? "" },
                token_initiated: { clicked: d.token_initiated?.clicked ?? 0, values: d.token_initiated?.values ?? null, token_no: d.token_initiated?.token_no ?? "", time: d.token_initiated?.time ?? "", file: null, fileData: d.token_initiated?.fileData ?? null },
                document_registered: { clicked: d.document_registered?.clicked ?? 0, values: d.document_registered?.values ?? null, document_no: d.document_registered?.document_no ?? "", file: null, fileData: d.document_registered?.fileData ?? null },
                document_pending: { clicked: d.document_pending?.clicked ?? 1, values: d.document_pending?.values ?? "no", document_no: d.document_pending?.document_no ?? "" },
                document_collected: { clicked: d.document_collected?.clicked ?? 0, values: d.document_collected?.values ?? null },
                document_scanned: { clicked: d.document_scanned?.clicked ?? 0, values: d.document_scanned?.values ?? null, file: null, fileData: d.document_scanned?.fileData ?? null },
                payment: { clicked: d.payment?.clicked ?? 0, values: d.payment?.values ?? null },
                other: { clicked: d.other?.clicked ?? 0, values: d.other?.values ?? null, cusDetail: d.other?.cusDetail ?? null },
            };
            set_Editd(initialEditd);
            setOriginalEditd(initialEditd);
        }
    }, [id, documents, sOffice, sVillage, sZone, sLayout]);

    const isAlreadyCompleted = originalData?.docstatus === "completed";
    

    const stageStatus = useMemo(() => {
        return {
            1: !!(formData.zoneId && formData.officeId && eusers.length > 0 && editonedoc.register_document && editonedoc.refered_by && buyere_Details.every(b => b.buyer_Detail?.name) && sellere_Details.every(s => s.seller_Detail?.name) && witnesse_Details.every(w => w.witness_Detail?.name)),
            2: !!(formData.villageId && formData.layoutId && editonedoc.approximate_quatation && editonedoc.sfno?.trim() && editonedoc.site_no?.trim() && parent_document.every(d => d.type && d.number)),
            3: status === 'offline' ? !!editd.value_check.values : (editd.value_check.values === 'no' || (editd.value_check.values === 'yes' && editd.value_check.doc_value?.trim())),
            4: status === 'online' ? true : !!(
            editd.draft_prepared.values && 
            (editd.draft_send.values === "yes" 
                ? editd.draft_send.through?.trim() && (
                    editd.draft_send.through === "online" 
                        ? (isAlreadyCompleted || editd.draft_send.file || editd.draft_send.fileData?.url)
                        : true
                  )
                : editd.draft_send.values) && 
            (editd.draft_approved.values === "yes" ? editd.draft_approved.by?.trim() : editd.draft_approved.values)
        ),
            5: alreadyAppliedEc === "yes"
                ? !!(
                    linkedEc?.ec?.id &&
                    (editd.certificate_received.values === 'yes'
                        ? (isAlreadyCompleted || editd.certificate_received.file || editd.certificate_received.fileData?.url)
                        : editd.certificate_received.values)
                  )
                : !!(
            (editd.certificate_applied.values === 'yes' ? editd.certificate_applied.eca_no?.trim() : editd.certificate_applied.values) && 
            (editd.certificate_received.values === 'yes'
                ? (isAlreadyCompleted || editd.certificate_received.file || editd.certificate_received.fileData?.url)
                : editd.certificate_received.values)
        ),
        6: status === 'online'
            ? !!(editd.deed_no.values === 'yes' ? editd.deed_no.tp_no?.trim() : editd.deed_no.values)
            : !!(
            (editd.deed_no.values === 'yes' ? editd.deed_no.tp_no?.trim() : editd.deed_no.values) && 
            (editd.token_initiated.values === 'yes' 
                ? editd.token_initiated.token_no?.trim() && editd.token_initiated.time && (isAlreadyCompleted || editd.token_initiated.file || editd.token_initiated.fileData?.url)
                : editd.token_initiated.values)
        ),    7: !!(
            (hasStampPaper === "no" || (stamp_Paper.length > 0 && stamp_Paper.every(s => s.value && s.number?.trim()))) &&
            editonedoc.payment_Info?.trim() &&
            (status === 'online' || (editd.document_pending.values === 'yes' ? editd.document_pending.document_no?.trim() : editd.document_pending.values)) &&
            (editd.document_registered.values === 'yes' ? editd.document_registered.document_no?.trim() : editd.document_registered.values)
        ),
            8: !!(
            (status === 'online' || editd.document_collected.values) && 
            (editd.document_scanned.values === 'yes'
                ? (editd.document_scanned.file || editd.document_scanned.fileData?.url) // Permanent file check
                : editd.document_scanned.values)
        ),9: !!(editd.payment.values && (editd.other.values === 'yes' ? editd.other.cusDetail?.name : editd.other.values === 'no'))
        };
    }, [formData, editonedoc, eusers, buyere_Details, sellere_Details, witnesse_Details, parent_document, editd, status, stamp_Paper, hasStampPaper, isAlreadyCompleted, alreadyAppliedEc, linkedEc]);

    useEffect(() => {
    // Only run this logic if we have the necessary data
    if (originalData && stageStatus) {
        
        // 1. Get an array of keys (steps) in order
        const steps = Object.keys(stageStatus).sort((a, b) => Number(a) - Number(b));
        
        // 2. Find the first step that is NOT complete (false)
        const firstIncompleteStep = steps.find(step => !stageStatus[step]);

        if (firstIncompleteStep) {
            // If an incomplete step exists, move to it
            setCurrentStep(Number(firstIncompleteStep));
        } else {
            // If all steps (1-9) are complete, stay at or move to the final step
            setCurrentStep(steps.length);
        }
    }
    // We include stageStatus so it re-checks whenever the form data changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [originalData]);

    const get_document = useCallback(() => set_options_edoc(docs?.map(v => ({ value: v.doc_Name, label: v.doc_Name?.toUpperCase() })) || []), [docs]);
    const get_customer = useCallback(() => set_eoptions(clients?.map(v => ({ value: v, label: `${v.name?.toUpperCase() || 'N/A'} - ${v.nick_name || ""} - ${v.mobile || ''}` })) || []), [clients]);
    const get_User = useCallback(() => set_eoptions_User(users?.map(u => ({ value: u.name, label: u.name?.toUpperCase() })) || []), [users]);

    useEffect(() => { get_User(); get_document(); get_customer(); }, [get_User, get_document, get_customer]);

    // Format merged list of people for the "Other Recipient" dropdown
    useEffect(() => {
        let op = [];
        if (editonedoc?.refered_by?.name) op.push({ value: editonedoc.refered_by, label: `${editonedoc.refered_by.name} - ${editonedoc.refered_by.mobile || ''}` });
        const formatDetails = (arr, key) => arr.filter(v => v[key]?.name).map(v => ({ value: v[key], label: `${v[key].name} - ${v[key].mobile || ''}` }));
        set_ooptions([...op, ...formatDetails(buyere_Details, 'buyer_Detail'), ...formatDetails(sellere_Details, 'seller_Detail'), ...formatDetails(witnesse_Details, 'witness_Detail')]);
    }, [editonedoc.refered_by, buyere_Details, sellere_Details, witnesse_Details]);


    // --- HELPERS ---
    const handleMsg = (type, payload) => { setActiveMsgText(MSGS[type](payload)); set_msg(true); setDim(true); };
    
    // Strict Role-Based Immutability Rule
    // Determines if it was previously saved as completed
    

    // Update canToggle to lock EVERYTHING if the doc is already completed
    const canToggle = (fieldKey) => { // Form is locked if completed!
        if (!originalEditd) return true;
        const clickData = originalEditd[fieldKey]?.clicked || 0;
        if (fieldKey === "document_pending") return user?.role === "user" ? clickData < 2 : true;
        return user?.role === "user" ? clickData < 1 : true;
    };

    // Tracking Stage Values
    const handleStageToggleChange = (field, val) => {
        // 1. Update the nested stage value
        set_Editd(prev => ({ ...prev, [field]: { ...prev[field], values: val } }));
        
        // 2. Safely add to the 'up' tracking array without duplicates
        set_Up(prev => prev.includes(field) ? prev : [...prev, field]);
    };

    const handleStageInput = (field, subField, val) => {
        // 1. Update the nested stage subfield (like eca_no, token_no, or 'file')
        set_Editd(prev => ({ ...prev, [field]: { ...prev[field], [subField]: val } }));
        
        // 2. Safely add to the 'up' tracking array without duplicates
        set_Up(prev => prev.includes(field) ? prev : [...prev, field]);
    };

    const handleDataChange = (e) => {
        const { name, value } = e.target;
        if (name === 'zoneId') {
            setFormData({ zoneId: value, officeId: '', villageId: '', layoutId: '' });
            set_editonedoc({ ...editonedoc, zone: sZone.find(z => String(z.id) === value)?.zoneName || '' });
        } else if (name === 'officeId') {
            setFormData({ ...formData, officeId: value, villageId: '', layoutId: '' });
            set_editonedoc({ ...editonedoc, register_office: formOffices.find(o => String(o.id) === value)?.officeName || '' });
        } else if (name === 'villageId') {
            setFormData({ ...formData, villageId: value, layoutId: '' });
            set_editonedoc({ ...editonedoc, village: formVillages.find(v => String(v.id) === value)?.villageName || '' });
        } else if (name === "layoutId") {
            setFormData({ ...formData, layoutId: value });
            set_editonedoc({ ...editonedoc, layout_name: formLayout.find(v => String(v.id) === value)?.layoutName || ''  });
        }
        else {
            set_editonedoc({ ...editonedoc, [name]: value  });
        }
        if (!up.includes(name)) set_Up(prev => [...prev, name]);
    };

    // Dynamic Fields Add/Remove/Change logic (Buyers/Sellers/Witnesses/Docs/Stamps) -> Mapped as requested
    const handleChangeOptionParty = (type, index, selected) => {
        const key = type === 'buyer' ? 'buyer_Detail' : type === 'seller' ? 'seller_Detail' : 'witness_Detail';
        const updater = type === 'buyer' ? set_Buyere_Details : type === 'seller' ? set_Sellere_Details : set_Witnesse_Details;
        
        updater(prev => {
            // 1. Create a shallow copy of the array
            const arr = [...prev];
            
            // 2. Create a shallow copy of the specific item being modified 
            // THIS IS THE KEY TO PREVENTING MUTATION OF THE ORIGINAL OBJECT
            arr[index] = { ...arr[index] };
            
            // 3. Update the value
            arr[index][key] = selected ? selected.value : {};
            
            return arr;
        });

        if (!up.includes(`${type}s`)) set_Up(p => [...p, `${type}s`]);
    };

    const handleCreate_cus = () => {
        setAdd(true)
        setDim(true)
        get_customer()
    }

    const steps = [
        { id: 1, label: "Referred & Client Details", complete: stageStatus[1] },
        { id: 2, label: "Document Details", complete: stageStatus[2] },
        { id: 3, label: "Guideline Value", complete: stageStatus[3] },
        { id: 4, label: "Offline Draft", complete: stageStatus[4] },
        { id: 5, label: "EC", complete: stageStatus[5] },
        { id: 6, label: "Online Draft", complete: stageStatus[6] },
        { id: 7, label: "Registration Process", complete: stageStatus[7] },
        { id: 8, label: "Return Collection", complete: stageStatus[8] },
        { id: 9, label: "Application Completed", complete: stageStatus[9] },
    ].filter(step => !(status === 'online' && step.id === 4));

    // Skip Offline Draft (step 4) when Presenceless is Online
    useEffect(() => {
        if (status === 'online' && currentStep === 4) {
            setCurrentStep(5);
        }
    }, [status, currentStep]);

    const getAdjacentStep = (from, direction) => {
        let next = from + direction;
        if (status === 'online' && next === 4) {
            next = from + (direction * 2);
        }
        return next;
    };

    const handlePresencelessChange = (nextStatus) => {
        setStatus(nextStatus);
        if (!up.includes('status')) set_Up(p => [...p, 'status']);
    };

    const validateMandatory = () => {
    // --- 1. Base Application Details (Step 1) ---
    if (!formData.zoneId || !formData.officeId || !eusers || eusers.length === 0) {
        showToast("Application Details (Zone, Office, Managed By) are mandatory!");
        return false;
    }
    
    if (!editonedoc?.register_document) { 
        showToast("Please select a Register Document type."); 
        return false; 
    }

    // --- 2. Online Value Check (Step 3) ---
    if (status === 'online' && editd?.value_check?.values === 'yes') {
        if (!editd.value_check.doc_value || editd.value_check.doc_value.toString().trim() === '') {
            showToast("Please enter the Guideline Value before proceeding.");
            return false; 
        }
    }

    // --- 3. Conditional Edit Fields (Steps 4 - 9) ---
    
    // Step 4: Offline Draft (only when Presenceless = Offline)
    if (status !== 'online') {
        if (editd?.draft_send?.values === "yes") {
            if (!editd.draft_send.through?.trim()) { 
                showToast("Please specify how the draft was sent (through)."); 
                return false; 
            }
            // NEW: File Check for Draft (ONLY IF ONLINE & BYPASS IF COMPLETED)
            if (editd.draft_send.through === "online" && !isAlreadyCompleted && !editd.draft_send.file && !editd.draft_send.fileData?.url) {
                showToast("Please upload the Draft PDF.");
                return false;
            }
        }
        
        if (editd?.draft_approved?.values === "yes" && !editd.draft_approved.by?.trim()) { 
            showToast("Please specify who approved the draft (by)."); 
            return false; 
        }
    }

    // Step 5: EC Process
    if (alreadyAppliedEc === "yes") {
        if (!linkedEc?.ec?.id) {
            showToast("Please select an already applied EC from the list.");
            return false;
        }
        if (editd?.certificate_received?.values === "yes" && !isAlreadyCompleted && !editd.certificate_received.file && !editd.certificate_received.fileData?.url) {
            showToast("Please upload the Received Certificate PDF.");
            return false;
        }
    } else {
        if (editd?.certificate_applied?.values === "yes" && !editd.certificate_applied.eca_no?.trim()) { 
            showToast("Please enter the ECA No."); 
            return false; 
        }
        // Check for Certificate File (BYPASS IF COMPLETED)
        if (editd?.certificate_received?.values === "yes" && !isAlreadyCompleted && !editd.certificate_received.file && !editd.certificate_received.fileData?.url) {
            showToast("Please upload the Received Certificate PDF.");
            return false;
        }
    }

    // Step 6: Online Draft / Token
    if (editd?.deed_no?.values === "yes" && !editd.deed_no.tp_no?.trim()) { 
        showToast("Please enter the TP No."); 
        return false; 
    }

    // Token Initiated only required when Presenceless = Offline
    if (status !== 'online' && editd?.token_initiated?.values === "yes") {
        if (!editd.token_initiated.token_no?.trim() || !editd.token_initiated.time) { 
            showToast("Please provide both Token No and Time."); 
            return false; 
        }
        // Check for Token Document File (BYPASS IF COMPLETED)
        if (!isAlreadyCompleted && !editd.token_initiated.file && !editd.token_initiated.fileData?.url) {
            showToast("Please upload the Token Document PDF.");
            return false;
        }
    }

    // Step 7: Registration Process
    if (status !== 'online' && editd?.document_pending?.values === "yes" && !editd.document_pending.document_no?.trim()) { 
        showToast("Please provide the Pending Document No."); 
        return false; 
    }

    if (editd?.document_registered?.values === "yes") {
        if (!editd.document_registered.document_no?.trim()) { 
            showToast("Please provide the Registered Document No."); 
            return false; 
        }
        // Registered Doc is PERMANENT. So we DO NOT bypass this check, even if completed
    }

    // Step 8: Return Collection
    // Scanned Doc is PERMANENT. So we DO NOT bypass this check, even if completed.
    if (editd?.document_scanned?.values === "yes" && !editd.document_scanned.file && !editd.document_scanned.fileData?.url) {
        showToast("Please upload the Scanned Document PDF.");
        return false;
    }

    // Step 9: Application Completed
    if (editd?.other?.values === "yes" && !editd.other.cusDetail?.name) { 
        showToast("Please select the Recipient from the dropdown."); 
        return false; 
    }

    return true; // Everything is filled out correctly!
};


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateMandatory()) return;

        // We no longer forcefully mark it as "completed". 
        // It will just maintain its current status (or default to "processing").
        const finalDocStatus = originalData?.docstatus || "processing";

        // 1. ASSEMBLE PRIMARY DATA
        const data1 = {
            application_no: editonedoc.application_no,
            date: editonedoc.date,
            zone: editonedoc?.zone?.toLowerCase(),
            register_office: editonedoc?.register_office?.toLowerCase(),
            register_document: editonedoc?.register_document?.toLowerCase(), 
            document_date: editonedoc.document_date,
            managed_By: eusers.map(u => u.value.toLowerCase()),
            refered_by: editonedoc.refered_by,
            buyers: buyere_Details,
            sellers: sellere_Details,
            witness: witnesse_Details,
            village: editonedoc?.village?.toLowerCase(),
            sfno: editonedoc.sfno,
            site_no: editonedoc.site_no,
            layout_name: editonedoc.layout_name?.toLowerCase(),
            parent_document: parent_document,
            stamp_Paper: hasStampPaper === "yes" ? stamp_Paper : [],
            approximate_quatation: editonedoc.approximate_quatation,
            document_split: editonedoc.document_split,
            status: status,
            remarks: editonedoc.remarks || "",
            internal_notes: editonedoc.internal_notes || "",
            payment_Info: editonedoc.payment_Info,
            already_applied_ec: alreadyAppliedEc === "yes" ? "yes" : "no",
            linked_ec: alreadyAppliedEc === "yes" && linkedEc?.ec
                ? {
                    id: linkedEc.ec.id || "",
                    application_no: linkedEc.ec.application_no || "",
                    owner_name: linkedEc.ec.owner?.name || linkedEc.ec.owner_name || "",
                    register_office: typeof linkedEc.ec.register_office === "string"
                        ? linkedEc.ec.register_office
                        : "",
                    docstatus: linkedEc.ec.docstatus || "",
                    ...(linkedEc.ec.ecno
                        ? {
                            ecno: {
                                values: linkedEc.ec.ecno.values ?? null,
                                no: linkedEc.ec.ecno.no || "",
                                clicked: linkedEc.ec.ecno.clicked || 0,
                            },
                        }
                        : {}),
                  }
                : null,
            docstatus: finalDocStatus // Kept in the same status
        };

        // =========================================================================
        // 2. RUN VALIDATIONS
        // =========================================================================
        if(data1.site_no && !/^[A-Za-z0-9/\-,.\s ]+$/.test(data1.site_no)) return showToast("Text field invalid! Only Numbers, Text, / in Site No");
        if(data1.sfno && !/^[A-Za-z0-9/\-,.\s ]+$/.test(data1.sfno)) return showToast("Text field invalid! Only Numbers, Text, / in SF No");
        if(data1.layout_name && !/^[A-Za-z,. ]+$/.test(data1.layout_name)) return showToast("Text field invalid! Only Text in Layout");
        
        for (let i = 0; i < data1.parent_document.length; i++) {
            const doc = data1.parent_document[i];
            if (doc.number && !/^[A-Za-z 0-9/|-]+$/.test(doc.number)) {
                return showToast(`Parent Document Row ${i + 1}: Only Text, Numbers, and / | - space allowed`);
            }
        }

        if (hasStampPaper === "yes") {
            for (let i = 0; i < data1.stamp_Paper.length; i++) {
                const doc = data1.stamp_Paper[i];
                if (doc.value && !/^[0-9 ]+$/.test(doc.value)) return showToast(`Stamp Paper Row ${i + 1}: Only numbers and spaces allowed in value`);
                if (doc.number && !/^[A-Za-z 0-9/|-]+$/.test(doc.number)) return showToast(`Stamp Paper Row ${i + 1}: Invalid format for number`);
            }
        }

        // =========================================================================
        // 3. CONSTRUCT DETAILED SUMMARY HTML (THE DIFF ENGINE)
        // =========================================================================
        let hasChanges = false;
        let tableRows = '';

        const addRow = (label, oldVal, newVal) => {
            hasChanges = true;
            tableRows += `
                <tr style="border-bottom: 1px solid #dee2e6;">
                    <td style="padding: 8px 4px; color: #495057; font-weight: 600; width: 25%; vertical-align: top;">${label}</td>
                    <td style="padding: 8px 4px; color: #dc3545; text-decoration: line-through; font-size: 11px; width: 35%; word-break: break-word; vertical-align: top;">${oldVal || 'N/A'}</td>
                    <td style="padding: 8px 4px; color: #198754; font-weight: bold; font-size: 12px; width: 40%; word-break: break-word; vertical-align: top;">${newVal || 'N/A'}</td>
                </tr>
            `;
        };

        // --- Data Extraction Helpers ---
        const extractName = (obj) => {
            if (!obj) return 'None';
            if (typeof obj === 'string') return obj;
            return obj.name || obj.label || 'None';
        };

        const getPartyNames = (arr, partyType) => {
            if (!Array.isArray(arr) || arr.length === 0) return 'None';
            return arr.map(item => {
                if (partyType === 'buyer') return extractName(item.buyer_Detail);
                if (partyType === 'seller') return extractName(item.seller_Detail);
                if (partyType === 'witness') return extractName(item.witness_Detail);
                return 'Unknown';
            }).join(', ');
        };

        // A. Check Basic String/Number Fields
        const basicFieldsMap = {
            zone: 'Zone', register_office: 'Office', village: 'Village', 
            register_document: 'Doc Nature', document_date: 'Doc Date', 
            sfno: 'S.F No.', site_no: 'Site No.', layout_name: 'Layout', 
            approximate_quatation: 'Quotation', document_split: 'Split Required', 
            status: 'Presenceless', payment_Info: 'Payment Details',
            
            // --- ADD THESE TWO LINES ---
            remarks: 'Remarks', 
            internal_notes: 'Internal Notes'
        };

        Object.keys(basicFieldsMap).forEach(key => {
            const oldVal = String(originalData[key] || '').trim().toUpperCase();
            const newVal = String(data1[key] || '').trim().toUpperCase();
            if (oldVal !== newVal) addRow(basicFieldsMap[key], oldVal, newVal);
        });

        // B. Check Referred By
        const oldRef = extractName(originalData.refered_by).toUpperCase();
        const newRef = extractName(data1.refered_by).toUpperCase();
        if (oldRef !== newRef) addRow('Referred By', oldRef, newRef);

        const getParentDocSummary = (arr) => {
            if (!Array.isArray(arr) || arr.length === 0) return 'None';
            return arr.map(item => `${item.type?.toUpperCase() || 'DOC'} (#${item.number || 'N/A'})`).join(', ');
        };

        const getStampSummary = (arr) => {
            if (!Array.isArray(arr) || arr.length === 0) return 'None';
            return arr.map(item => `₹${item.value || '0'} (#${item.number || 'N/A'})`).join(', ');
        };

        // C. Check Arrays & Complex Data
        if (up.includes('buyers')) {
            addRow('Buyers', getPartyNames(originalData.buyers, 'buyer'), getPartyNames(buyere_Details, 'buyer'));
        }
        if (up.includes('sellers')) {
            addRow('Sellers', getPartyNames(originalData.sellers, 'seller'), getPartyNames(sellere_Details, 'seller'));
        }
        if (up.includes('witness')) {
            addRow('Witnesses', getPartyNames(originalData.witness, 'witness'), getPartyNames(witnesse_Details, 'witness'));
        }
        if (up.includes('parent_document')) {
            addRow('Parent Docs', getParentDocSummary(originalData.parent_document), getParentDocSummary(parent_document));
        }
        if (up.includes('stamp_Paper')) {
            addRow('Stamp Papers', getStampSummary(originalData.stamp_Paper), getStampSummary(data1.stamp_Paper));
        }
        if (up.includes('managed_By')) {
            const oldManagers = Array.isArray(originalData.managed_By) ? originalData.managed_By.join(', ').toUpperCase() : 'NONE';
            const newManagers = eusers.map(u => extractName(u)).join(', ').toUpperCase();
            if (oldManagers !== newManagers) addRow('Managed By', oldManagers, newManagers);
        }

        const oldApplied = (originalData.already_applied_ec || "no").toUpperCase();
        const newApplied = (data1.already_applied_ec || "no").toUpperCase();
        if (oldApplied !== newApplied) addRow('Already Applied EC', oldApplied, newApplied);

        const oldLinked = originalData.linked_ec
            ? `${originalData.linked_ec.application_no || "N/A"} / ${(originalData.linked_ec.owner_name || "N/A").toUpperCase()}`
            : "NONE";
        const newLinked = data1.linked_ec
            ? `${data1.linked_ec.application_no || "N/A"} / ${(data1.linked_ec.owner_name || "N/A").toUpperCase()}`
            : "NONE";
        if (oldLinked !== newLinked) addRow('Linked EC', oldLinked, newLinked);

        // D. Check Workflow Tracking Stages (editd)
        const getBadge = (val, extraText = "") => {
            if (val === 'yes') return `<span style="color: #198754; font-weight: bold;">YES ${extraText ? `(${extraText})` : ''}</span>`;
            if (val === 'no') return `<span style="color: #dc3545; font-weight: bold;">NO</span>`;
            return `<span style="color: #6c757d; font-weight: bold; font-size: 11px;">PENDING</span>`;
        };

        const stageExtras = {
            value_check: { prop: 'doc_value', prefix: '₹' },
            certificate_applied: { prop: 'eca_no', prefix: '#' },
            token_initiated: { prop: 'token_no', prefix: 'D-' },
            document_registered: { prop: 'document_no', prefix: '#' },
            document_pending: { prop: 'document_no', prefix: '#' },
            deed_no: { prop: 'tp_no', prefix: 'TP-' },
            draft_approved: { prop: 'by', prefix: 'By: ' },
            draft_send: { prop: 'through', prefix: 'Via: ' }
        };

        const updateableTrackingStages = Object.keys(editd);
        updateableTrackingStages.forEach(key => {
            if (up.includes(key)) {
                const current = editd[key];
                const original = originalEditd[key];
                
                const displayKey = key.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
                
                let oldString = original?.values?.toUpperCase() || 'PENDING';
                let newString = current?.values?.toUpperCase() || 'PENDING';

                if (stageExtras[key]) {
                    const { prop, prefix } = stageExtras[key];
                    if (original?.[prop]) oldString += ` (${prefix}${original[prop]})`;
                    if (current?.[prop]) newString += ` (${prefix}${current[prop]})`;
                }

                if (key === 'other') {
                    if (original?.cusDetail?.name) oldString += ` (${original.cusDetail.name})`;
                    if (current?.cusDetail?.name) newString += ` (${current.cusDetail.name})`;
                }

                // FILE UPLOAD TRACKER LOGIC
                const oldHasFile = !!original?.fileData?.url;
                const isNewFile = current?.file instanceof File; // Detects newly selected file
                const newHasFile = isNewFile || !!current?.fileData?.url;

                const oldFileHtml = oldHasFile ? `<div style="font-size: 10px; color: #6c757d; margin-top: 4px;">📎 Saved File</div>` : '';
                const newFileHtml = isNewFile 
                    ? `<div style="font-size: 10px; color: #0dcaf0; margin-top: 4px; font-weight: bold;">📎 New: ${current.file.name}</div>` 
                    : (newHasFile ? `<div style="font-size: 10px; color: #0d6efd; margin-top: 4px;">📎 Saved File Kept</div>` : '');

                if (oldString !== newString || isNewFile || oldHasFile !== newHasFile) {
                    hasChanges = true;
                    tableRows += `
                        <tr style="border-bottom: 1px solid #dee2e6;">
                            <td style="padding: 8px 4px; color: #495057; font-weight: 600; vertical-align: middle;">Stage: ${displayKey}</td>
                            <td style="padding: 8px 4px; font-size: 11px; vertical-align: middle;">
                                <span style="text-decoration: line-through; color: #adb5bd;">${oldString}</span>
                                ${oldFileHtml}
                            </td>
                            <td style="padding: 8px 4px; vertical-align: middle;">
                                ${getBadge(current.values, newString.includes('(') ? newString.split('(')[1].replace(')','') : '')}
                                ${newFileHtml}
                            </td>
                        </tr>
                    `;
                }
            }
        });

        // =========================================================================
        // 4. FIRE CONFIRMATION WALL
        // =========================================================================
        const summaryHtml = `
        <div style="text-align: left; font-size: 13px; font-family: 'Segoe UI', Tahoma, sans-serif; max-height: 65vh; overflow-y: auto;">
            <div style="position: sticky; top: 0; background: white; padding-bottom: 10px; border-bottom: 2px solid #8a2be2; z-index: 10; display: flex; justify-content: space-between; align-items: center;">
                <span style="font-size: 18px; color: #4a127e;"><strong># ${editonedoc.application_no || 'NEW'}</strong></span>
                <span style="font-size: 11px; background: #e6f2ff; color: #004085; padding: 3px 8px; border-radius: 4px; font-weight: bold;">Preview Updates</span>
            </div>
            
            <div style="margin-top: 15px; border: 1px solid #dee2e6; border-radius: 8px; overflow: hidden;">
                <div style="background-color: #f8f9fa; padding: 10px 12px; font-weight: bold; color: #343a40; border-bottom: 1px solid #dee2e6;">
                    DETAILED CHANGES
                </div>
                <div style="padding: 10px;">
                    ${hasChanges 
                        ? `<table style="width: 100%; font-size: 12px; border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th style="text-align: left; padding-bottom: 6px; color: #6c757d; font-size: 10px;">FIELD</th>
                                    <th style="text-align: left; padding-bottom: 6px; color: #6c757d; font-size: 10px;">PREVIOUS</th>
                                    <th style="text-align: left; padding-bottom: 6px; color: #6c757d; font-size: 10px;">NEW UPDATE</th>
                                </tr>
                            </thead>
                            <tbody>${tableRows}</tbody>
                        </table>`
                        : `<div style="text-align: center; color: #6c757d; font-style: italic; padding: 15px 0;">No changes detected. Proceed to save?</div>`
                    }
                </div>
            </div>
        </div>
        `;

        const result = await Swal.fire({
            title: 'Confirm Application Updates',
            html: summaryHtml,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#8a2be2",
            confirmButtonText: "Confirm & Save",
            cancelButtonText: "Cancel",
            width: '38em' 
        });

        if (!result.isConfirmed) return;
        
        // 5. START LOADING STATE
        setBt(true);

        /*try {
            if (!authStore.currentUser) await signInAnonymously(authStore);
        } catch (error) {
            console.error("Auth Error:", error);
            setBt(false);
            return showToast("Storage Auth failed. Check console.");
        }*/

        // 6. FIREBASE STORAGE REPLACE LOGIC (CLEANUP REMOVED)
        const fileStages = [
            { key: 'draft_send', suffix: 'draft' },
            { key: 'certificate_received', suffix: 'ec' },
            { key: 'token_initiated', suffix: 'token' },
            { key: 'document_registered', suffix: 'registered' },
            { key: 'document_scanned', suffix: 'scanned' }
        ];

        const app_No_safe = editonedoc.application_no.replaceAll('/', '_');
        const updatedFileData = {};

        try {
            for (const stage of fileStages) {
                const currentStage = editd[stage.key];
                const originalStage = originalEditd[stage.key];

                // If user uploaded a brand new file
                if (currentStage?.file instanceof File) {
                    // Delete old file if it existed, so we don't clog up storage with orphans
                    if (originalStage?.fileData?.path) {
                        try { await deleteObject(ref(storage, originalStage.fileData.path)); } 
                        catch (e) { console.warn("Old file delete failed"); }
                    }
                    // Upload New
                    const storagePath = `document/${app_No_safe}/${app_No_safe}_${stage.suffix}.pdf`;
                    const fileRef = ref(storage, storagePath);
                    await uploadBytesResumable(fileRef, currentStage.file);
                    const downloadURL = await getDownloadURL(fileRef);
                    updatedFileData[stage.key] = { url: downloadURL, path: storagePath };
                } 
                // Otherwise, keep the original file data exactly as it was
                else {
                    updatedFileData[stage.key] = currentStage?.fileData || originalStage?.fileData || null;
                }
            }
        }  catch (err) {
        console.error("Storage Error Detail:", err);
        setBt(false);
        
        // Extract exact storage errors
        let detailedError = "Failed to process files in Firebase Storage.";
        if (err.code === 'storage/unauthorized') {
            detailedError = "Storage Error: You do not have permission. Check your Firebase Storage Rules!";
        } else if (err.code === 'storage/canceled') {
            detailedError = "Storage Error: The file upload was canceled.";
        } else if (err.code === 'storage/unknown') {
            detailedError = "Storage Error: An unknown error occurred. Possibly a CORS issue.";
        } else if (err.message) {
            detailedError = `Storage Error: ${err.message}`;
        }
        
        return showToast(detailedError);
    }

        // 7. PROCESS CLICKS FOR API PREPARATION
        const processClicks = (field) => {
            const current = editd[field];
            const originalVal = originalEditd[field]?.values || null;
            const { file, ...safeField } = current; // Strip out the local File object so JSON doesn't crash
            
            // Attach the freshly computed file data URLs
            if (updatedFileData.hasOwnProperty(field)) {
                safeField.fileData = updatedFileData[field];
            }

            return {
                ...safeField,
                clicked: current.values !== originalVal ? (current.clicked + 1) : current.clicked
            };
        };

        const data = {};
        updateableTrackingStages.forEach(key => {
            // Only update if the user explicitly modified it or added a file
            if (up.includes(key)) {
                data[key] = processClicks(key);
            }
        });

        // 8. API CALL
        try {
            await api.patch(`/updateone_Customer/${id}`, { data, data1 });
            
            Swal.fire({ text: 'Updated Successfully', icon: "success", width: "28em", timer: 2000, showConfirmButton: false, timerProgressBar: true });
            
            if (onclose) onclose();
            fetchDocuments();
            set_docedit(false);
            setDim(false);
            
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Unauthorized! Please login again.");
                localStorage.removeItem("token");
                navigate("/login");
            } else {
                showToast("Update failed. Please check your inputs.");
                console.log(error);
            }
        } finally {
            setBt(false);
        }
    };

    const selectStyles = {
        control: (base, state) => ({ ...base, minHeight: '38px', borderRadius: '0.375rem', borderColor: state.isFocused ? 'var(--brand-purple)' : '#dee2e6', boxShadow: state.isFocused ? '0 0 0 1px var(--brand-purple)' : 'none' }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: base => ({ ...base, zIndex: 9999 })
    };

    const handleCreate_doc = async (value) => {
        const add = value.trim().toLowerCase().replace(/\s+/g, ' ');
        if (!/^[A-Za-z ]+$/.test(add)) {
          return showToast("Can't Add Special Character at Nature of Document");
        }
        const result = await Swal.fire({
          title: "Confirm Document Type",
          text: `Do you want to add "${add}" to the document list?`,
          icon: "question",
          width: "28em",
          showCancelButton: true,
          confirmButtonColor: "#8a2be2", // Themed Purple
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, add it",
          scrollbarPadding: false,
        });
        
        if (result.isConfirmed) {
          try {
            const res = await api.post('/add_New_Document', { doc_Name: add });
            await Swal.fire({
              text: res.data.message,
              icon: "success",
              width: "28em",
              timer: 2000,
              showConfirmButton: false,
              timerProgressBar: true 
            });
            fetchDocs();
          } catch (error) {
            showToast("Error: Could not save the document type.");
          }
        }
      };

    const validateCurrentStep = (stepToValidate = currentStep) => {
    switch (stepToValidate) {
        case 1:
            if (!formData.zoneId) { showToast("Please select a Zone."); return false; }
            if (!formData.officeId) { showToast("Please select an Office."); return false; }
            if (!eusers || eusers.length === 0) { showToast("Please assign at least one User."); return false; }
            if (!editonedoc.register_document) { showToast("Please select a Register Document type."); return false; }
            break;

        case 2:
            break;

        case 3:
            if (status === 'online' && editd.value_check.values === 'yes') {
                if (!editd.value_check.doc_value || editd.value_check.doc_value.toString().trim() === '') {
                    showToast("Please enter the Guideline Value before proceeding.");
                    return false; 
                }
            }
            break;

        case 4:
            // Offline Draft is hidden when Presenceless = Online
            if (status === 'online') break;
            if (editd.draft_send.values === "yes") {
    if (!editd.draft_send.through?.trim()) { 
        showToast("Please specify how the draft was sent (through)."); 
        return false; 
    }
    // NEW: File Check for Draft (ONLY IF ONLINE & BYPASS IF COMPLETED)
    if (editd.draft_send.through === "online" && !isAlreadyCompleted && !editd.draft_send.file && !editd.draft_send.fileData?.url) { 
        showToast("Please upload the Draft PDF."); 
        return false; 
    }
}
            if (editd.draft_approved.values === "yes" && !editd.draft_approved.by?.trim()) { 
                showToast("Please specify who approved the draft (by)."); 
                return false; 
            }
            break;

        case 5:
            if (alreadyAppliedEc === "yes") {
                if (!linkedEc?.ec?.id) {
                    showToast("Please select an already applied EC from the list.");
                    return false;
                }
                if (editd.certificate_received.values === "yes" && !isAlreadyCompleted && !editd.certificate_received.file && !editd.certificate_received.fileData?.url) { 
                    showToast("Please upload the Received Certificate PDF."); 
                    return false; 
                }
            } else {
                if (editd.certificate_applied.values === "yes" && !editd.certificate_applied.eca_no?.trim()) { 
                    showToast("Please enter the ECA No."); 
                    return false; 
                }
                // NEW: File Check for EC Certificate (BYPASS IF COMPLETED)
                if (editd.certificate_received.values === "yes" && !isAlreadyCompleted && !editd.certificate_received.file && !editd.certificate_received.fileData?.url) { 
                    showToast("Please upload the Received Certificate PDF."); 
                    return false; 
                }
            }
            break;

        case 6:
            if (editd.deed_no.values === "yes" && !editd.deed_no.tp_no?.trim()) { 
                showToast("Please enter the TP No."); 
                return false; 
            }
            // Token Initiated is hidden when Presenceless = Online
            if (status !== 'online' && editd.token_initiated.values === "yes") {
                if (!editd.token_initiated.token_no?.trim() || !editd.token_initiated.time) { 
                    showToast("Please provide both Token No and Time."); 
                    return false; 
                }
                // NEW: File Check for Token (BYPASS IF COMPLETED)
                if (!isAlreadyCompleted && !editd.token_initiated.file && !editd.token_initiated.fileData?.url) { 
                    showToast("Please upload the Token Document PDF."); 
                    return false; 
                }
            }
            break;

        case 7:
            if (status !== 'online' && editd.document_pending.values === "yes" && !editd.document_pending.document_no?.trim()) { 
                showToast("Please provide the Pending Document No."); 
                return false; 
            }
            if (editd.document_registered.values === "yes") {
                if (!editd.document_registered.document_no?.trim()) { 
                    showToast("Please provide the Registered Document No."); 
                    return false; 
                }
                // ADDED BACK: File Check for Registered Document (PERMANENT - NEVER BYPASS)
            }
            break;

         case 8:
        // NEW: File Check for Scanned Document (PERMANENT - NEVER BYPASS)
            if (editd.document_scanned.values === "yes" && !editd.document_scanned.file && !editd.document_scanned.fileData?.url) { 
                showToast("Please upload the Scanned Document PDF."); 
                return false; 
            }
            break;

        case 9:
            if (editd.other.values === "yes" && !editd.other.cusDetail?.name) { 
                showToast("Please select the Recipient from the dropdown."); 
                return false; 
            }
            break;

        default:
            break;
    }

    return true; // All checks passed, allows navigation
};

const layoutOptions = formLayout
    .slice()
    .sort((a, b) => (a.layoutName || "").localeCompare(b.layoutName || ""))
    .map(v => ({
      value: v.id,
      label: v.layoutName.toUpperCase()
    }));

  const selectedLayout = layoutOptions.find(opt => opt.value === formData.layoutId) || null;

  const handleAddLayout = (inputValue) => {
  if (!formData.villageId) {
    Swal.fire('Wait!', 'Please select a village first', 'warning');
    return;
  }

  Swal.fire({
    title: 'Add New Layout',
    input: 'text',
    inputValue: inputValue, // Pre-fills the popup with what the user just typed!
    inputLabel: 'Layout Name',
    showCancelButton: true,
    confirmButtonColor: '#6f42c1', 
    inputValidator: (value) => {
      if (!value) return 'Layout name is required!';
      const regex = /^[a-zA-Z0-9\s-]+$/; 
      if (!regex.test(value)) return 'Letters, numbers, and hyphens only!';
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        Swal.showLoading();
        // Assuming your backend returns the newly created object ID in res.data
        await api.post("/add_v_s", {
          type: "layout",
          name: result.value.trim().toLowerCase(),
          parentId: formData.villageId 
        });
        
        await fetchSLayout(); 
        Swal.fire({ icon: 'success', title: 'Added!', timer: 1500, showConfirmButton: false });

        // OPTIONAL: Auto-select the newly created layout if your API returns its ID
        // if (res.data?.id) {
        //   setFormData({ ...formData, layoutId: res.data.id });
        //   set_Layout(result.value.trim().toUpperCase());
        // }

      } catch (error) {
        Swal.fire('Error', error.response?.data?.message || 'Failed to add', 'error');
      }
    }
  });
};

    return (
        <div className="editdoc container-xxl bg-light p-4 rounded shadow-lg">
            <ToastContainer />
            
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="text-secondary fw-bold mb-0">
                    Edit Document 
                    {isAlreadyCompleted && <span className="badge bg-success ms-3 fs-6 align-middle text-uppercase"><i className="bi bi-check-circle-fill me-2"></i>Fully Completed</span>}
                </h3>
                <Button onClick={() => { set_docedit(false); setDim(false); }} variant="danger" className="rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '35px', height: '35px' }}>
                    <MdClose size={20} />
                </Button>
            </div>
            
            <SimpleBar style={{ width: '100%', height: '75vh' }} className="pe-3">
                {originalData && (
                    <Form onSubmit={handleSubmit} className="pb-4">
                        
                        {/* CONSTANT HEADER: Application Details */}
                        <Card className="shadow-sm border-0 mb-4 rounded-3" style={{ borderTop: '5px solid #8a2be2' }}>
                            <Card.Header className="bg-white pt-3 border-0">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <div className="rounded-circle me-2" style={{ width: '10px', height: '10px', backgroundColor: '#8a2be2' }}></div>
                                        <h5 className="fw-bold mb-0" style={{ color: '#4a127e', letterSpacing: '-0.5px' }}>
                                            Application Details
                                        </h5>
                                    </div>
                                    <span className="badge rounded-pill bg-light text-dark border px-3 py-2">
                                        Last Updated: {originalData?.updatedAt?._seconds 
    ? new Date(originalData.updatedAt._seconds * 1000).toLocaleString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }) 
    : 'Unknown'}
                                    </span>
                                </div>
                            </Card.Header>
                            
                            <Card.Body className="px-4 pb-4">
                                <Row className="g-4"> 
                                    {/* Row 1 */}
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>App No.</Form.Label>
                                            <Form.Control readOnly value={editonedoc.application_no || ''} className="bg-light border-0 fw-semibold" style={{ color: '#555' }} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>Date</Form.Label>
                                            <Form.Control readOnly value={editonedoc.date || ''} className="bg-light border-0 fw-semibold" style={{ color: '#555' }} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>Zone <span className="text-danger">*</span></Form.Label>
                                            <Form.Select 
                                                className="shadow-none border-secondary-subtle"
                                                name="zoneId"
                                                value={formData.zoneId || ""} 
                                                disabled={user.role === 'user'} 
                                                onChange={handleDataChange}
                                            >
                                                <option value="">Select Zone</option>
                                                {[...DATA.zones].sort((a, b) => a.zoneName.localeCompare(b.zoneName)).map((z) => (<option key={z.id} value={z.id}>{z.zoneName.toUpperCase()}</option>))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {/* Row 2 */}
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>Office <span className="text-danger">*</span></Form.Label>
                                            <Form.Select 
                                                className="shadow-none border-secondary-subtle"
                                                name="officeId"
                                                disabled={user.role === 'user' || !formData.zoneId} 
                                                value={formData.officeId || ""} 
                                                onChange={handleDataChange}
                                            >
                                                <option value="">Select Office</option>
                                                {[...formOffices].sort((a, b) => a.officeName.localeCompare(b.officeName)).map((o) => (<option key={o.id} value={o.id}>{o.officeName.toUpperCase()}</option>))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>
                                                Document Date
                                            </Form.Label>
                                            <Form.Control 
                                                type="date"
                                                name="document_date"
                                                disabled={user.role === 'user'}
                                                className="bg-light border-0 fw-semibold shadow-none" 
                                                style={{ color: '#555', cursor: 'pointer' }} 
                                                value={editonedoc.document_date || ''} 
                                                onChange={(e) => {
                                                    set_editonedoc({ ...editonedoc, document_date: e.target.value });
                                                    if (!up.includes('document_date')) set_Up(p => [...p, 'document_date']);
                                                }}
                                                isInvalid={!editonedoc.document_date}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please select today or a future date.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group className="position-relative">
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>
                                                Document Nature <span className="text-danger">*</span>
                                            </Form.Label>
                                            <CreatableSelect 
                                                isClearable 
                                                options={options_edoc} 
                                                isDisabled={user.role === 'user'}
                                                value={editonedoc.register_document ? { value: editonedoc.register_document, label: editonedoc.register_document.toUpperCase() } : null} 
                                                onChange={(val) => { 
                                                    set_editonedoc(p => ({ ...p, register_document: val?.value || "" })); 
                                                    if (!up.includes('register_document')) set_Up(p => [...p, 'register_document']); 
                                                }} 
                                                placeholder="Search..." 
                                                styles={selectStyles}
                                                menuPortalTarget={document.body}
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/* Row 3 */}
                                    <Col md={4}>
                                        <Form.Group className="position-relative">
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>
                                                Managed By <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select 
                                                isMulti 
                                                isDisabled={user.role === "user"} 
                                                options={eoption_User} 
                                                value={eusers} 
                                                onChange={(val) => { 
                                                    set_eusers(val ? [...val] : []); 
                                                    if (!up.includes('managed_By')) set_Up(p => [...p, 'managed_By']); 
                                                }} 
                                                placeholder="Select users..."
                                                styles={selectStyles}
                                                menuPortalTarget={document.body}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4} className="d-flex align-items-end">
                                        <Button 
                                            variant="primary"
                                            size="sm" 
                                            className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                                            onClick={() => handleMsg('WELCOME', { app_no: editonedoc.application_no })}
                                            style={{ backgroundColor: '#8a2be2', border: 'none', fontSize: '12px' }}
                                        >
                                            WELCOME MESSAGE
                                        </Button>
                                    </Col>

                                    <Col md={4} className="d-flex align-items-end">
                                        <div className="d-flex align-items-center gap-2 flex-wrap w-100">
                                            <span className="small fw-bold text-muted text-uppercase" style={{ fontSize: '0.75rem' }}>
                                                Presenceless
                                            </span>
                                            <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                                                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '11px', color: status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Offline</Typography>
                                                    <AntSwitch
                                                        checked={status === 'online'}
                                                        disabled={user.role === 'user'}
                                                        onChange={(e) => handlePresencelessChange(e.target.checked ? 'online' : 'offline')}
                                                    />
                                                    <Typography sx={{ fontSize: '11px', color: status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Online</Typography>
                                                </Stack>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* STEPPER PROGRESS BAR */}
                        <div className={`d-flex align-items-center mb-5 px-3 overflow-auto py-4 custom-scrollbar ${
                            // Only center if the content is smaller than the screen
                            // On mobile, this ensures it starts at the beginning (left-aligned)
                            steps.length > 5 ? 'justify-content-start justify-content-md-center' : 'justify-content-center'
                        }`}
                        style={{ 
                            WebkitOverflowScrolling: 'touch', // Smooth scrolling for iOS
                            gap: '0' // Prevents unexpected gaps
                        }}>
                            {steps.map((step, index) => (
                            <React.Fragment key={step.id}>
                                {/* --- STEP NODE --- */}
                                <div 
                                className="d-flex flex-column align-items-center position-relative" 
                                style={{ 
                                    minWidth: '110px', // Slightly wider to accommodate longer labels
                                    cursor: 'pointer',
                                    padding: '5px 0' 
                                }}
                                onClick={() => {
                                    
                                    if (!validateCurrentStep(step.id)) {
        return; // Stops here, toast is triggered inside the function
    }
                                    setCurrentStep(step.id);
                                }}
                                >
                                <div 
                                    style={{
                                    width: '44px', height: '44px', borderRadius: '50%',
                                    display: 'flex', justifyContent: 'center', alignItems: 'center', 
                                    fontWeight: '700', fontSize: '14px', transition: 'all 0.4s ease',
                                    
                                    // Halo effect for the currently active stage
                                    boxShadow: currentStep === step.id 
                                        ? '0 0 0 2px white, 0 0 0 5px #8a2be2' 
                                        : '0 2px 5px rgba(0,0,0,0.05)',
                                    
                                    // Logic: Purple if complete, Yellow if current, White if pending
                                    backgroundColor: step.complete ? '#8a2be2' : (currentStep === step.id ? '#ece917' : '#ffffff'),
                                    color: step.complete ? '#ece917' : (currentStep === step.id ? '#4a127e' : '#adb5bd'),
                                    border: (step.complete || currentStep === step.id) ? 'none' : '2px solid #e9ecef',
                                    zIndex: 2,
                                    transform: currentStep === step.id ? 'translateY(-3px)' : 'translateY(0)',
                                    }}
                                >
                                    {step.complete ? '✓' : (index + 1).toString().padStart(2, '0')}
                                </div>
                                
                                <span className="mt-2 fw-bold text-center text-uppercase" style={{ 
                                    fontSize: '8.5px', // Smaller font to ensure 9 steps fit comfortably
                                    letterSpacing: '0.5px',
                                    maxWidth: '90px',
                                    lineHeight: '1.2',
                                    color: currentStep === step.id ? '#4a127e' : (step.complete ? '#8a2be2' : '#ced4da'),
                                    transition: 'all 0.3s'
                                }}>
                                    {step.label}
                                </span>
                                </div>

                                {/* --- LINE CONNECTOR --- */}
                                {index < steps.length - 1 && (
                                <div style={{ 
                                    flex: '1', 
                                    minWidth: '30px',
                                    height: '6px', 
                                    backgroundColor: '#f1f3f5', 
                                    margin: '0 -20px', // Tucks line behind circles
                                    marginBottom: '26px', // Aligns with center of 44px circle + label spacing
                                    position: 'relative',
                                    borderRadius: '10px',
                                    zIndex: 1,
                                    overflow: 'hidden'
                                }}>
                                    <motion.div 
                                    initial={false}
                                    animate={{ width: step.complete ? '100%' : '0%' }} 
                                    transition={{ duration: 0.5, ease: "easeInOut" }}
                                    style={{ 
                                        height: '100%', 
                                        background: '#8a2be2',
                                    }} 
                                    />
                                </div>
                                )}
                            </React.Fragment>
                            ))}
                        </div>

                        <AnimatePresence mode="wait">
                            {/* STEP 1: Parties */}
                            {currentStep === 1 && (
                                <motion.div key="s1" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}>
                                    <Card className="shadow-sm mb-4 border-0 rounded-3">
                                        <Card.Header className="bg-white border-0 pt-4 px-4">
                                            <h4 className="fw-bold mb-0" style={{ color: "#4a127e", letterSpacing: '-0.5px' }}>
                                                Reference & Client Details
                                            </h4>
                                            <p className="text-muted small">Manage the primary parties involved in this application.</p>
                                        </Card.Header>
                                        
                                        <Card.Body className="px-4 pb-4">
                                            {/* --- SECTION: REFERRED BY --- */}
                                            <div className="mb-5 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                                                <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#8a2be2', fontSize: '0.8rem' }}>
                                                    <span className="me-2">Referred By</span>
                                                    <hr className="flex-grow-1 my-0 opacity-10" />
                                                </h6>
                                                <Row className="g-3">
                                                    <Form.Group as={Col} xs={12} md={3}>
                                                        <Form.Label className="small fw-bold text-muted text-uppercase">Name {editonedoc.refered_by?.cid && <span className="badge bg-primary ms-1">{editonedoc.refered_by.cid}</span>}</Form.Label>
                                                        <CreatableSelect
                                                            isClearable
                                                            value={editonedoc.refered_by?.name ? { value: editonedoc.refered_by, label: editonedoc.refered_by.name.toUpperCase() } : null}
                                                            options={eoptions || []}
                                                            isDisabled={user.role === 'user'}
                                                            onCreateOption={() => setAdd(true)}
                                                            placeholder="Search..."
                                                            onChange={(val) => { 
                                                                set_editonedoc({ ...editonedoc, refered_by: val ? val.value : null }); 
                                                                if (!up.includes('refered_by')) set_Up(p => [...p, 'refered_by']); 
                                                            }}
                                                            styles={selectStyles}
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xs={12} md={3}>
                                                        <Form.Label className="small fw-bold text-muted text-uppercase">Address</Form.Label>
                                                        <Form.Control readOnly value={TitleCase(editonedoc.refered_by?.address)} className="bg-white border-0 shadow-none" style={{ fontSize: '14px' }} />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xs={12} md={3}>
                                                        <Form.Label className="small fw-bold text-muted text-uppercase">District</Form.Label>
                                                        <Form.Control readOnly value={TitleCase(editonedoc.refered_by?.city)} className="bg-white border-0 shadow-none" style={{ fontSize: '14px' }} />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xs={12} md={3}>
                                                        <Form.Label className="small fw-bold text-muted text-uppercase">Mobile No.</Form.Label>
                                                        <Form.Control readOnly value={editonedoc.refered_by?.mobile || ''} className="bg-white border-0 shadow-none" style={{ fontSize: '14px' }} />
                                                    </Form.Group>
                                                </Row>
                                            </div>

                                            {/* --- SECTION: BUYER DETAILS --- */}
                                            <div className="mb-5">
                                                <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#198754', fontSize: '0.8rem' }}>
                                                    <span className="me-2">Buyer Details</span>
                                                    <hr className="flex-grow-1 my-0 opacity-10" />
                                                </h6>
                                                {buyere_Details.map((fields, index) => (
                                                    <div key={index} className="mb-3 p-3 border-start border-4 border-success rounded-end bg-light shadow-sm">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <span className="fw-bold small text-dark">Buyer #{index + 1} {fields.buyer_Detail?.cid && <span className="badge bg-success ms-2">{fields.buyer_Detail.cid}</span>}</span>
                                                            {user.role === 'admin' && buyere_Details.length > 1 && (
                                                                <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => { set_Buyere_Details(p => p.filter((_, i) => i !== index)); if (!up.includes('buyers')) set_Up(p => [...p, 'buyers']); }}>
                                                                    <MdClose /> Remove
                                                                </Button>
                                                            )}
                                                        </div>
                                                        <Row className="g-3">
                                                            <Form.Group as={Col} xs={12} md={3}>
                                                                <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                                                <CreatableSelect
                                                                    isDisabled={user.role === 'user'}
                                                                    isClearable
                                                                    value={fields.buyer_Detail?.name ? { value: fields.buyer_Detail, label: fields.buyer_Detail.name.toUpperCase() } : null}
                                                                    options={eoptions || []}
                                                                    onChange={(v, a) => { handleChangeOptionParty('buyer', index, v); if (!up.includes('buyers')) set_Up(p => [...p, 'buyers']); }}
                                                                    styles={selectStyles}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label><Form.Control readOnly value={TitleCase(fields.buyer_Detail?.address)} className="bg-white border-0" /></Form.Group>
                                                            <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label><Form.Control readOnly value={TitleCase(fields.buyer_Detail?.city)} className="bg-white border-0" /></Form.Group>
                                                            <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">MOBILE</Form.Label><Form.Control readOnly value={fields.buyer_Detail?.mobile || ''} className="bg-white border-0" /></Form.Group>
                                                            
                                                        </Row>
                                                    </div>
                                                ))}
                                                {user.role === 'admin' && <Button variant="outline-success" className="rounded-pill px-3 fw-bold" size="sm" onClick={() => set_Buyere_Details([...buyere_Details, { buyer_Detail: {}, buyer_aadhar: "" }])}><MdAdd /> Add Another Buyer</Button>}
                                            </div>

                                            {/* --- SECTION: SELLER DETAILS --- */}
                                            <div className="mb-5">
                                                <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#fd7e14', fontSize: '0.8rem' }}>
                                                    <span className="me-2">Seller Details</span>
                                                    <hr className="flex-grow-1 my-0 opacity-10" />
                                                </h6>
                                                {sellere_Details.map((fields, index) => (
                                                    <div key={index} className="mb-3 p-3 border-start border-4 border-warning rounded-end bg-light shadow-sm">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <span className="fw-bold small text-dark">Seller #{index + 1} {fields.seller_Detail?.cid && <span className="badge bg-warning text-dark ms-2">{fields.seller_Detail.cid}</span>}</span>
                                                            {user.role === 'admin'&& sellere_Details.length > 1 && (
                                                                <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => { set_Sellere_Details(p => p.filter((_, i) => i !== index)); if (!up.includes('sellers')) set_Up(p => [...p, 'sellers']); }}>
                                                                    <MdClose /> Remove
                                                                </Button>
                                                            )}
                                                        </div>
                                                        <Row className="g-3">
                                                            <Form.Group as={Col} xs={12} md={3}>
                                                                <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                                                <CreatableSelect
                                                                    isClearable
                                                                    isDisabled={user.role === 'user'}
                                                                    value={fields.seller_Detail?.name ? { value: fields.seller_Detail, label: fields.seller_Detail.name.toUpperCase() } : null}
                                                                    options={eoptions || []}
                                                                    onChange={(v, a) => { handleChangeOptionParty('seller', index, v); if (!up.includes('sellers')) set_Up(p => [...p, 'sellers']); }}
                                                                    styles={selectStyles}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label><Form.Control readOnly value={TitleCase(fields.seller_Detail?.address)} className="bg-white border-0" /></Form.Group>
                                                            <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label><Form.Control readOnly value={TitleCase(fields.seller_Detail?.city)} className="bg-white border-0" /></Form.Group>
                                                            <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">MOBILE</Form.Label><Form.Control readOnly value={fields.seller_Detail?.mobile || ''} className="bg-white border-0" /></Form.Group>
                                                        </Row>
                                                    </div>
                                                ))}
                                                {user.role === 'admin' && <Button variant="outline-warning" className="rounded-pill px-3 fw-bold text-dark" size="sm" onClick={() => set_Sellere_Details([...sellere_Details, { seller_Detail: {}, seller_aadhar: "" }])}><MdAdd /> Add Another Seller</Button>}
                                            </div>

                                            <div>
                                                <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#0dcaf0', fontSize: '0.8rem' }}>
                                                    <span className="me-2">Witness Details</span>
                                                    <hr className="flex-grow-1 my-0 opacity-10" />
                                                </h6>
                                                <Row className="g-3">
                                                    {witnesse_Details.map((fields, index) => (
                                                        <Col xs={12} key={index}>
                                                            <div className="p-3 border rounded-3 bg-white shadow-sm border-info-subtle">
                                                                <h6 className="small fw-bold text-info mb-3">Witness {index + 1} {fields.witness_Detail?.cid && <span className="badge bg-info text-dark ms-2">{fields.witness_Detail.cid}</span>}</h6>
                                                                <Row className="g-3">
                                                                    <Form.Group as={Col} md={3}>
                                                                        <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                                                        <CreatableSelect
                                                                            onCreateOption={handleCreate_cus}
                                                                            isClearable
                                                                            isDisabled={user.role === 'user'}
                                                                            value={fields.witness_Detail.name ? { value: fields.witness_Detail, label: fields.witness_Detail.name?.toUpperCase() } : null}
                                                                            options={eoptions || []}
                                                                            onChange={(v, a) =>{ handleChangeOptionParty('witness', index, v); if (!up.includes('witness')) set_Up(p => [...p, 'witness']);}}
                                                                            styles={selectStyles}
                                                                        />
                                                                    </Form.Group>
                                                                    <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label><Form.Control readOnly value={TitleCase(fields.witness_Detail.address)} className="bg-light border-0" /></Form.Group>
                                                                    <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label><Form.Control readOnly value={TitleCase(fields.witness_Detail.city)} className="bg-light border-0" /></Form.Group>
                                                                    <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">MOBILE</Form.Label><Form.Control readOnly value={fields.witness_Detail.mobile || ''} className="bg-light border-0" /></Form.Group>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </motion.div>
                            )}

                            {/* STEP 2: Land & Parent Docs */}
                            {currentStep === 2 && (
                                <motion.div key="s2" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                    <Card className="shadow-sm border-0 rounded-3">
                                        <Card.Body className="p-4">
                                            <h5 className="fw-bold mb-4 d-flex align-items-center" style={{ color: "#4a127e" }}>Document Details</h5>
                                            
                                            {/* LOCATION & LAND */}
                                            <div className="mb-4">
                                                <Row className="g-3">
                                                    <Col md={3}>
                                                        <Form.Label className="small fw-bold text-secondary">VILLAGE</Form.Label>
                                                        <Form.Select className="shadow-none border-secondary-subtle" name="villageId" value={formData.villageId || ""} disabled={!formData.officeId || user.role === 'user'} onChange={handleDataChange}>
                                                            <option value="">Choose Village...</option>
                                                            {[...formVillages].sort((a, b) => a.villageName.localeCompare(b.villageName)).map((v) => (<option key={v.id} value={v.id}>{v.villageName.toUpperCase()}</option>))}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Label className="small fw-bold text-secondary">LAYOUT</Form.Label>
      <CreatableSelect
            isClearable
            // Maintains your exact disabled logic for villages and user roles
            isDisabled={!formData.villageId || user.role === 'user'} 
            options={layoutOptions}
            value={selectedLayout}
            placeholder="Choose Layout..."
            name="layoutId"
            onChange={(selectedOption) => {
                // Creates a simulated event object so your existing handleDataChange works perfectly
                handleDataChange({
                    target: {
                        name: "layoutId",
                        value: selectedOption ? selectedOption.value : ""
                    }
                });
            }}
            onCreateOption={(inputValue) => handleAddLayout(inputValue)}
            
            // Replicates the "shadow-none border-secondary-subtle" Bootstrap classes
            styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
                    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
                    '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#dee2e6' },
                })
            }}
        />
                                                    </Col>
                                                    <Col md={3}>
                                                    <Form.Label className="small fw-bold text-secondary">S.F NO.</Form.Label>
                                                    <Form.Control 
                                                        className="shadow-none" 
                                                        name="sfno" 
                                                        type="text" 
                                                        placeholder="SF No."
                                                        // Shows red border if on Step 2 and sfno is empty or whitespace
                                                        isInvalid={currentStep === 2 && !editonedoc.sfno?.trim()}
                                                        value={editonedoc.sfno || ''} 
                                                        disabled={user.role === 'user'}
                                                        onChange={(e) => {
                                                        const { value } = e.target;
                                                        // Allows Alphanumeric, slash, hyphen, comma, and spaces
                                                        const regex = /^[A-Za-z0-9/\-,\s ]*$/;
                                                        if (regex.test(value)) {
                                                            handleDataChange(e);
                                                        }
                                                        }} 
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        S.F Number is required.
                                                    </Form.Control.Feedback>
                                                    </Col>

                                                    <Col md={3}>
                                                    <Form.Label className="small fw-bold text-secondary">SITE NO.</Form.Label>
                                                    <Form.Control 
                                                        className="shadow-none" 
                                                        name="site_no" 
                                                        type="text" 
                                                        disabled={user.role === 'user'}
                                                        placeholder="Site No."
                                                        // Shows red border if on Step 2 and site_no is empty or whitespace
                                                        isInvalid={currentStep === 2 && !editonedoc.site_no?.trim()}
                                                        value={editonedoc.site_no || ''} 
                                                        onChange={(e) => {
                                                        const { value } = e.target;
                                                        const regex = /^[A-Za-z0-9/\-,\s ]*$/;
                                                        if (regex.test(value)) {
                                                            handleDataChange(e);
                                                        }
                                                        }} 
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Site Number is required (A-Z, 0-9, / - ,)
                                                    </Form.Control.Feedback>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* PARENT DOCS */}
                                            <div className="mb-5">
                                                <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#6c757d', fontSize: '0.8rem' }}>
                                                    <span className="me-2">Parent Document Details</span>
                                                    <hr className="flex-grow-1 my-0 opacity-10" />
                                                </h6>

                                                {parent_document.map((doc, idx) => (
                                                    <div key={idx} className="mb-3 p-3 border-start border-4 border-secondary rounded-end bg-white shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="fw-bold small text-dark">Document #{idx + 1}</span>
                                                        {user.role === 'admin' && parent_document.length > 1 && (
                                                        <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => set_Parent_Document(p => p.filter((_, i) => i !== idx))}>
                                                            <MdClose /> Remove
                                                        </Button>
                                                        )}
                                                    </div>

                                                    <Row className="g-3">
                                                        <Col md={6}>
                                                        <Form.Label className="small fw-bold text-muted">DOCUMENT TYPE</Form.Label>
                                                        <CreatableSelect 
                                                            onCreateOption={handleCreate_doc} 
                                                            isDisabled={user.role === 'user'} 
                                                            isClearable 
                                                            value={doc.type ? { value: doc.type, label: doc.type.toUpperCase() } : null} 
                                                            options={options_edoc} 
                                                            onChange={(val) => { 
                                                                set_Parent_Document(prev => prev.map((item, i) => 
                                                                    i === idx ? { ...item, type: val?.value || "" } : item
                                                                ));
                                                                if (!up.includes('parent_document')) set_Up(p => [...p, 'parent_document']); 
                                                            }} 
                                                            styles={selectStyles} 
                                                            menuPortalTarget={document.body} 
                                                        />
                                                        </Col>
                                                        <Col md={6}>
                                                        <Form.Label className="small fw-bold text-muted">DOCUMENT NUMBER</Form.Label>
                                                        <Form.Control 
                                                            disabled={user.role === 'user'} 
                                                            type="text" 
                                                            placeholder="Enter document number..."  
                                                            value={doc.number || ''} 
                                                            onChange={(e) => { 
                                                                const newNumber = e.target.value;
                                                                set_Parent_Document(prev => prev.map((item, i) => 
                                                                    i === idx ? { ...item, number: newNumber } : item
                                                                ));
                                                                if (!up.includes('parent_document')) set_Up(p => [...p, 'parent_document']); 
                                                            }} 
                                                        />
                                                        </Col>
                                                    </Row>
                                                    </div>
                                                ))}

                                                {user.role === 'admin' && (
                                                    <Button 
                                                    variant="outline-secondary" 
                                                    className="rounded-pill px-3 fw-bold" 
                                                    size="sm" 
                                                    onClick={() => set_Parent_Document(p => [...p, { type: '', number: '' }])}
                                                    >
                                                    <MdAdd /> Add New Document
                                                    </Button>
                                                )}
                                            </div>

                                            {/* QUOTATION & SPLIT */}
                                            <Row className="g-4 pt-3 border-top">
                                                <Col md={6}>
                                                    <Form.Label className="small fw-bold text-secondary text-uppercase">Approx. Quotation (₹)</Form.Label>
                                                    <div className="input-group">
                                                        <span className="input-group-text bg-white">₹</span>
                                                        <Form.Control 
                                                            className="shadow-none" 
                                                            name="approximate_quatation"
                                                            disabled={user.role === 'user'} 
                                                            type="text" 
                                                            inputMode="numeric" 
                                                            placeholder="0"
                                                            pattern="[0-9]*" 
                                                            isInvalid={currentStep === 2 && (editonedoc.approximate_quatation === undefined || editonedoc.approximate_quatation === null || editonedoc.approximate_quatation.toString().trim() === '')}
                                                            value={editonedoc.approximate_quatation || ''}
                                                            onChange={(e) => {
                                                                // 1. Get the current value
                                                                const { value } = e.target;
                                                                // Allows only digits 0-9
                                                                const regex = /^[0-9]*$/;
                                                                if (regex.test(value)) {
                                                                    handleDataChange(e);
                                                                }
                                                            }}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Approximate Quotation is required.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Label className="small fw-bold text-secondary text-uppercase d-block mb-2">Split Required?</Form.Label>
                                                    <div className="d-flex align-items-center p-2 rounded-3 border bg-light" style={{ width: 'fit-content' }}>
                                                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                            <Typography sx={{ fontSize: '12px', color: editonedoc.document_split === 'no' ? '#28a745' : '#adb5bd', fontWeight: 700 }}>COPY</Typography>
                                                            <AntSwitch checked={editonedoc.document_split === 'yes'} disabled={user.role === 'user'} onChange={(e) => { set_editonedoc({ ...editonedoc, document_split: e.target.checked ? 'yes' : 'no' }); if (!up.includes('document_split')) set_Up(p => [...p, 'document_split']); }} />
                                                            <Typography sx={{ fontSize: '12px', color: editonedoc.document_split === 'yes' ? '#8a2be2' : '#adb5bd', fontWeight: 700 }}>SPLIT</Typography>
                                                        </Stack>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </motion.div>
                            )}

                            {/* STEP 3: Guideline Value */}
                            {currentStep === 3 && (
                                <motion.div key="s3" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                    <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                        <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                                            <div><h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>Guideline Value</h5><p className="text-muted small mb-0">Verify current market value.</p></div>
                                            <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3">
                                                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '12px', color: status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 700 }}>OFFLINE</Typography>
                                                    <AntSwitch checked={status === 'online'} disabled={user.role === 'user'} onChange={(e) => handlePresencelessChange(e.target.checked ? 'online' : 'offline')} />
                                                    <Typography sx={{ fontSize: '12px', color: status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 700 }}>ONLINE</Typography>
                                                </Stack>
                                            </div>
                                        </Card.Header>
                                        <Card.Body className="text-center py-5 px-4">
                                            <div className="mb-4"><Form.Label className="fw-bold d-block h6" style={{ color: '#555' }}>Has Guideline Value been checked?</Form.Label></div>
                                            <div className="d-flex flex-column align-items-center gap-3">
                                                <div className="p-3 rounded-4 bg-light border border-dashed">
                                                    <ThreeStateToggle value={editd.value_check.values} onChange={(val) => handleStageToggleChange('value_check', val)} disabled={!canToggle('value_check')} />
                                                </div>
                                                <span className="d-inline-flex overflow-hidden align-items-center" style={{ height: '18px' }}>
    <AnimatePresence mode="wait">
        <motion.span
            key={editd.value_check.values || 'pending'} /* Fallback key for null */
            initial={{ y: 15, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -15, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fw-bold text-uppercase" 
            style={{ 
                fontSize: '12px', 
                color: editd.value_check.values === 'yes' ? '#28a745' : (editd.value_check.values === 'no' ? '#dc3545' : '#adb5bd') 
            }}
        >
            {editd.value_check.values === 'yes' ? '● Verified' : editd.value_check.values === 'no' ? '● Not Verified' : '● Pending'}
        </motion.span>
    </AnimatePresence>
</span>

                                                <AnimatePresence>
                                                    {status === 'online' && editd.value_check.values === 'yes' && (
                                                        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="w-100 mt-4">
                                                            <Form.Group className="mx-auto p-4 rounded-3 border-start border-4 border-success bg-white shadow-sm" style={{ maxWidth: '400px' }}>
                                                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">Guideline Value (₹)</Form.Label>
                                                                <div className="input-group input-group-lg">
                                                                    <span className="input-group-text bg-white text-muted border-end-0">₹</span>
                                                                    <Form.Control 
                                                                        type="text" 
                                                                        inputMode="numeric" 
                                                                        pattern="[0-9]*"
                                                                        placeholder="0"
                                                                        // Validates based on Step 3 logic: if 'yes' is selected online, it cannot be empty
                                                                        isInvalid={currentStep === 3 && status !== 'offline' && editd.value_check.values === 'yes' && (editd.value_check.doc_value === undefined || editd.value_check.doc_value === null || editd.value_check.doc_value.toString().trim() === '')}
                                                                        value={editd.value_check.doc_value || ''} 
                                                                        onChange={(e) => {
                                                                            const { value } = e.target;
                                                                            // Force the value to contain only numbers by stripping anything else
                                                                            const numericValue = value.replace(/[^0-9]/g, '');
                                                                            
                                                                            // Pass the cleaned number string to your existing handler
                                                                            handleStageInput('value_check', 'doc_value', numericValue);
                                                                        }} 
                                                                        className="text-center fw-bold border-start-0 shadow-none" 
                                                                        style={{ border: '1px solid #dee2e6' }} 
                                                                        disabled={!canToggle('value_check')} 
                                                                    />
                                                                    {/* Optional: Add feedback so the user knows why it's red */}
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Document Value is required.
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </motion.div>
                                                    )}
                                                </AnimatePresence>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </motion.div>
                            )}

                            {/* STEP 4: Offline Draft */}
                            {currentStep === 4 && (
                                <motion.div key="s4" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                    <Card className="shadow-sm border-0 rounded-3">
                                        <Card.Header className="bg-white border-0 pt-4 px-4">
                                            <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>Offline Draft</h5>
                                            <p className="text-muted small">Track the preparation, delivery, and approval of the draft.</p>
                                        </Card.Header>
                                        
                                        <Card.Body className="px-4 pb-5">
                                            <Row className="g-4">
                                                
                                                {/* --- STAGE 1: PREPARATION --- */}
                                                <Col md={4}>
                                                    <div className={`p-3 rounded-3 border h-100 ${editd.draft_prepared.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                                        <Form.Group>
                                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">1. Draft Prepared</Form.Label>
                                                            <ThreeStateToggle 
                                                                value={editd.draft_prepared.values} 
                                                                onChange={(val) => handleStageToggleChange('draft_prepared', val)} 
                                                                disabled={!canToggle('draft_prepared')} 
                                                            />
                                                            <div className="mt-2 text-center overflow-hidden" style={{ height: '24px' }}>
    <AnimatePresence mode="wait">
        <motion.div
            key={editd.draft_prepared.values} /* The key tells Framer Motion to animate when this value changes */
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
        >
            <small className={`fw-bold ${editd.draft_prepared.values === 'yes' ? 'text-success' :editd.draft_prepared.values === 'no' ? 'text-danger':'text-muted'}`}>
                {editd.draft_prepared.values === 'yes' ? 'Ready for Sending' : editd.draft_prepared.values === 'no' ? 'Declined' : 'Awaiting Preparation'}
            </small>
        </motion.div>
    </AnimatePresence>
</div>
                                                        </Form.Group>
                                                    </div>
                                                </Col>

                                                {/* --- STAGE 2: DELIVERY --- */}
                                                <Col md={4}>
                                                    <div className={`p-3 rounded-3 border h-100 ${editd.draft_send.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                                                        <Form.Group>
                                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">2. Draft Sent</Form.Label>
                                                            <ThreeStateToggle 
                                                                value={editd.draft_send.values} 
                                                                onChange={(val) => handleStageToggleChange('draft_send', val)} 
                                                                disabled={!canToggle('draft_send')} 
                                                            />

                                                            <AnimatePresence>
                                                                {editd.draft_send.values === 'yes' && (
                                                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                                                        <Form.Label className="small fw-bold text-secondary mb-1">THROUGH</Form.Label>
                                                                        <Select 
                                                                            placeholder="Select"
                                                                            options={[{value:'offline',label:'OFFLINE'},{value:'online',label:'ONLINE'}]}
                                                                            styles={{
                                                                                ...selectStyles,
                                                                                // Add red border if on Step 4 and field is empty
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    borderColor: (currentStep === 4 && !editd.draft_send.through) ? '#dc3545' : base.borderColor,
                                                                                })
                                                                            }}
                                                                            menuPortalTarget={document.body} 
                                                                            menuPosition="fixed" 
                                                                            isDisabled={!canToggle('draft_send')}
                                                                            value={editd.draft_send.through 
                                                                                ? { value: editd.draft_send.through, label: editd.draft_send.through.toUpperCase() } 
                                                                                : null 
                                                                            }
                                                                            onChange={(val) => handleStageInput('draft_send', 'through', val?.value || '')}
                                                                        />
                                                                        {/* Custom validation feedback for Select */}
                                                                        {currentStep === 4 && !editd.draft_send.through && (
                                                                            <div className="text-danger mt-1" style={{fontSize: '10px'}}>Required field</div>
                                                                        )}
                                                                        
                                                                        {/* --- WRAPPED FILE UPLOAD FIELD IN ONLINE CONDITION --- */}
                                                                        {editd?.draft_send?.through === 'online' && (
                                                                            <>
                                                                                {isAlreadyCompleted ? (
                                                                                    <div className="alert alert-secondary py-2 mt-3 small text-center mb-0 border-0 fw-bold">
                                                                                        <i className="bi bi-shield-check me-2 text-success"></i>Temporary file removed after completion.
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="mt-3">
                                                                                        <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD DRAFT (PDF, Max 5MB)</Form.Label>
                                                                                        
                                                                                        {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
                                                                                        {!(editd.draft_send.file || editd.draft_send.fileData?.url) ? (
                                                                                            <Form.Control 
                                                                                                type="file" accept="application/pdf" size="sm"
                                                                                                disabled={!canToggle('draft_send')}
                                                                                                onChange={(e) => {
                                                                                                    const file = e.target.files[0];
                                                                                                    if (file) {
                                                                                                        if (file.type !== 'application/pdf') { showToast('Only PDFs allowed.'); e.target.value = null; return; }
                                                                                                        if (file.size > 5 * 1024 * 1024) { showToast('File must be under 5 MB.'); e.target.value = null; return; }
                                                                                                        handleStageInput('draft_send', 'file', file);
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
                                                                                            <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                                                                                <span className="small text-truncate text-muted fw-bold me-2">
                                                                                                    <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                                                                    {editd.draft_send.file ? editd.draft_send.file.name : 'Draft_Document.pdf'}
                                                                                                </span>
                                                                                                <div className="d-flex gap-2">
                                                                                                    <Button 
                                                                                                        variant="outline-primary" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                                                        onClick={() => {
                                                                                                            const url = editd.draft_send.file ? URL.createObjectURL(editd.draft_send.file) : editd.draft_send.fileData.url;
                                                                                                            window.open(url, '_blank');
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="bi bi-eye me-1"></i> VIEW
                                                                                                    </Button>
                                                                                                    <Button 
                                                                                                        variant="outline-danger" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                                                        disabled={!canToggle('draft_send')}
                                                                                                        onClick={() => {
                                                                                                            // Clear both state values to completely remove the file
                                                                                                            handleStageInput('draft_send', 'file', null);
                                                                                                            if (editd.draft_send.fileData) {
                                                                                                                handleStageInput('draft_send', 'fileData', null);
                                                                                                            }
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="bi bi-trash me-1"></i> REMOVE
                                                                                                    </Button>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </motion.div>
                                                                )}
                                                            </AnimatePresence>
                                                        </Form.Group>
                                                    </div>
                                                </Col>

                                                {/* --- STAGE 3: APPROVAL --- */}
                                                <Col md={4}>
                                                    <div className={`p-3 rounded-3 border h-100 ${editd.draft_approved.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                                                        <Form.Group>
                                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">3. Draft Approved</Form.Label>
                                                            <ThreeStateToggle 
                                                                value={editd.draft_approved.values} 
                                                                onChange={(val) => handleStageToggleChange('draft_approved', val)} 
                                                                disabled={!canToggle('draft_approved')} 
                                                            />

                                                            <AnimatePresence>
                                                                {editd.draft_approved.values === 'yes' && (
                                                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                                                        <Form.Label className="small fw-bold text-secondary mb-1">APPROVED BY</Form.Label>
                                                                        <Form.Control
                                                                            className="shadow-none border bg-white"
                                                                            placeholder="Enter Name"
                                                                            // Removed TitleCase wrapper. Put it back around editd...by if you have that utility function imported
                                                                            value={editd.draft_approved.by || ''}
                                                                            disabled={!canToggle('draft_approved')}
                                                                            onChange={(e) => handleStageInput('draft_approved', 'by', e.target.value)} 
                                                                            // Trigger red border if Step 4 is active but field is empty
                                                                            isInvalid={currentStep === 4 && !editd.draft_approved.by?.trim()}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid" style={{fontSize: '10px'}}>Required field</Form.Control.Feedback>
                                                                    </motion.div>
                                                                )}
                                                            </AnimatePresence>
                                                        </Form.Group>
                                                    </div>
                                                </Col>

                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </motion.div>
                            )}

                            {/* STEP 5: EC Process */}
                            {currentStep === 5 && (
                            <motion.div key="st5" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
                                    <div>
                                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple, #4a127e)" }}>
                                        Encumbrance Certificate Process
                                        </h5>
                                        <p className="text-muted small mb-0">Monitor the application and receipt of the Encumbrance Certificate.</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <span className="small fw-bold text-muted text-uppercase" style={{ fontSize: '0.75rem' }}>
                                            Already Applied EC?
                                        </span>
                                        <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '11px', color: alreadyAppliedEc === 'no' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>No</Typography>
                                                <AntSwitch
                                                    checked={alreadyAppliedEc === 'yes'}
                                                    disabled={user.role === 'user'}
                                                    onChange={(e) => {
                                                        const next = e.target.checked ? 'yes' : 'no';
                                                        setAlreadyAppliedEc(next);
                                                        if (!up.includes('already_applied_ec')) set_Up(p => [...p, 'already_applied_ec']);
                                                        if (!up.includes('linked_ec')) set_Up(p => [...p, 'linked_ec']);
                                                        if (next === 'yes') {
                                                            setLinkedEc(null);
                                                            set_Editd(prev => ({
                                                                ...prev,
                                                                certificate_applied: { ...prev.certificate_applied, values: null, eca_no: "" },
                                                            }));
                                                            set_Up(p => {
                                                                const nextUp = [...p];
                                                                if (!nextUp.includes('certificate_applied')) nextUp.push('certificate_applied');
                                                                return nextUp;
                                                            });
                                                        } else {
                                                            setLinkedEc(null);
                                                        }
                                                    }}
                                                />
                                                <Typography sx={{ fontSize: '11px', color: alreadyAppliedEc === 'yes' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Yes</Typography>
                                            </Stack>
                                        </div>
                                    </div>
                                </Card.Header>
                                
                                <Card.Body className="px-4 pb-5">
                                    {alreadyAppliedEc === 'yes' ? (
                                        <Row className="g-4">
                                            <Col xs={12} md={6}>
                                                <Form.Group className="p-4 rounded-3 border h-100 bg-white">
                                                    <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">
                                                        1. Select EC from My EC <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        isClearable
                                                        isDisabled={user.role === 'user'}
                                                        options={(ecs || [])
                                                            .filter((d) => d.docstatus !== "processing")
                                                            .slice()
                                                            .sort((a, b) => (a.application_no || "").localeCompare(b.application_no || ""))
                                                            .map((ec) => ({
                                                                value: ec.id,
                                                                label: `${(ec.application_no || "N/A").toUpperCase()} — ${(ec.owner?.name || "N/A").toUpperCase()}`,
                                                                ec,
                                                            }))}
                                                        value={linkedEc}
                                                        onChange={(opt) => {
                                                            setLinkedEc(opt);
                                                            if (!up.includes('linked_ec')) set_Up(p => [...p, 'linked_ec']);
                                                            if (!up.includes('already_applied_ec')) set_Up(p => [...p, 'already_applied_ec']);
                                                        }}
                                                        placeholder="Search application no. or owner..."
                                                        styles={selectStyles}
                                                        menuPortalTarget={document.body}
                                                    />
                                                    {!linkedEc && (
                                                        <small className="text-danger d-block mt-2">Please select an EC application.</small>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            {/* --- EC RECEIVED (also for Already Applied Yes) --- */}
                                            <Col xs={12} md={6}>
                                                <div className={`p-4 rounded-3 border h-100 ${editd.certificate_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                                <Form.Group>
                                                    <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                                    2. Certificate Received
                                                    </Form.Label>
                                                    
                                                    <div className="mb-3">
                                                    <ThreeStateToggle 
                                                        value={editd.certificate_received.values} 
                                                        onChange={(val) => handleStageToggleChange('certificate_received', val)} 
                                                        disabled={!canToggle('certificate_received')}
                                                    />
                                                    </div>

                                                    <AnimatePresence>
                                                    {editd.certificate_received.values === 'yes' && (
                                                        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}>
                                                            <div className="alert alert-success border-0 small py-2 text-center fw-bold mb-3">
                                                                Encumbrance Certificate Application Complete
                                                            </div>

                                                            {isAlreadyCompleted ? (
                                                                <div className="alert alert-secondary py-2 mt-3 small text-center mb-0 border-0 fw-bold">
                                                                    <i className="bi bi-shield-check me-2 text-success"></i>Temporary file removed after completion.
                                                                </div>
                                                            ) : (
                                                                <div className="mt-3">
                                                                    <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD CERTIFICATE (PDF, Max 5MB)</Form.Label>
                                                                    {!(editd.certificate_received.file || editd.certificate_received.fileData?.url) ? (
                                                                        <Form.Control 
                                                                            type="file" accept="application/pdf" size="sm"
                                                                            disabled={!canToggle('certificate_received')}
                                                                            onChange={(e) => {
                                                                                const file = e.target.files[0];
                                                                                if (file) {
                                                                                    if (file.type !== 'application/pdf') { showToast('Only PDFs allowed.'); e.target.value = null; return; }
                                                                                    if (file.size > 5 * 1024 * 1024) { showToast('File must be under 5 MB.'); e.target.value = null; return; }
                                                                                    handleStageInput('certificate_received', 'file', file);
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                                                            <span className="small text-truncate text-muted fw-bold me-2">
                                                                                <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                                                {editd.certificate_received.file ? editd.certificate_received.file.name : 'EC_Certificate.pdf'}
                                                                            </span>
                                                                            <div className="d-flex gap-2">
                                                                                <Button 
                                                                                    variant="outline-primary" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                                    onClick={() => {
                                                                                        const url = editd.certificate_received.file ? URL.createObjectURL(editd.certificate_received.file) : editd.certificate_received.fileData.url;
                                                                                        window.open(url, '_blank');
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-eye me-1"></i> VIEW
                                                                                </Button>
                                                                                <Button 
                                                                                    variant="outline-danger" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                                    disabled={!canToggle('certificate_received')}
                                                                                    onClick={() => {
                                                                                        handleStageInput('certificate_received', 'file', null);
                                                                                        if (editd.certificate_received.fileData) {
                                                                                            handleStageInput('certificate_received', 'fileData', null);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-trash me-1"></i> REMOVE
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )} <br/>
                                                            <Button 
                                                                variant="success"
                                                                size="sm" 
                                                                className="w-100 py-2 fw-bold shadow-sm rounded-pill" 
                                                                onClick={() => handleMsg('EC', { 
                                                                app_no: editonedoc?.application_no, 
                                                                ec_no: linkedEc?.ec?.application_no
                                                                  ? String(linkedEc.ec.application_no).toUpperCase()
                                                                  : `ECA/Online/${editd.certificate_applied?.eca_no || ''}/${new Date().getFullYear()}` 
                                                                })}
                                                            >
                                                                <i className="bi bi-send-check me-2"></i>EC RECEIVED MESSAGE
                                                            </Button>
                                                        </motion.div>
                                                    )}
                                                    </AnimatePresence>
                                                </Form.Group>
                                                </div>
                                            </Col>
                                        </Row>
                                    ) : (
                                    <Row className="g-4">
                                    
                                    {/* --- EC APPLICATION APPLIED --- */}
                                    <Col xs={12} md={6}>
                                        <div className={`p-4 rounded-3 border h-100 ${editd.certificate_applied.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            1. Application Applied {status?.status === "online" && "(Online)"}
                                            </Form.Label>
                                            
                                            <div className="mb-3">
                                            <ThreeStateToggle 
                                                value={editd.certificate_applied.values} 
                                                onChange={(val) => handleStageToggleChange('certificate_applied', val)} 
                                                disabled={!canToggle('certificate_applied')}
                                            />
                                            </div>
                                            
                                            <AnimatePresence>
                                            {editd.certificate_applied.values === 'yes' && (
                                                <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="overflow-hidden">
                                                <Form.Label className="small fw-bold text-secondary text-uppercase mb-1">
                                                    ECA NO. <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control 
                                                    className="shadow-none border-secondary-subtle fw-bold" 
                                                    value={editd.certificate_applied.eca_no || ''} 
                                                    inputMode="numeric" // Forces numeric keypad on mobile devices
                                                    type="text"        // Better validation/styling control than type="number"
                                                    placeholder="Ex: 85942" 
                                                    isInvalid={!editd.certificate_applied.eca_no}
                                                    disabled={!canToggle('certificate_applied')}
                                                    onChange={(e) => {
                                                    const val = e.target.value;
                                                    // RegEx fallback to ensure strictly digits only
                                                    if (/^\d*$/.test(val)) {
                                                        handleStageInput('certificate_applied', 'eca_no', val);
                                                    }
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    ECA Number is required (Digits only).
                                                </Form.Control.Feedback>
                                                </motion.div>
                                            )}
                                            </AnimatePresence>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* --- EC RECEIVED --- */}
                                    <Col xs={12} md={6}>
                                        <div className={`p-4 rounded-3 border h-100 ${editd.certificate_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            2. Certificate Received
                                            </Form.Label>
                                            
                                            <div className="mb-3">
                                            <ThreeStateToggle 
                                                value={editd.certificate_received.values} 
                                                onChange={(val) => handleStageToggleChange('certificate_received', val)} 
                                                disabled={!canToggle('certificate_received')}
                                            />
                                            </div>

                                            <AnimatePresence>
                                            {editd.certificate_received.values === 'yes' && (
                                                <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}>
                                                    <div className="alert alert-success border-0 small py-2 text-center fw-bold mb-3">
                                                        Encumbrance Certificate Application Complete
                                                    </div>

                                                    {/* --- UPDATED FILE UPLOAD SECTION --- */}
                                                    {isAlreadyCompleted ? (
                                                        <div className="alert alert-secondary py-2 mt-3 small text-center mb-0 border-0 fw-bold">
                                                            <i className="bi bi-shield-check me-2 text-success"></i>Temporary file removed after completion.
                                                        </div>
                                                    ) : (
                                                        <div className="mt-3">
                                                            <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD CERTIFICATE (PDF, Max 5MB)</Form.Label>
                                                            
                                                            {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
                                                            {!(editd.certificate_received.file || editd.certificate_received.fileData?.url) ? (
                                                                <Form.Control 
                                                                    type="file" accept="application/pdf" size="sm"
                                                                    disabled={!canToggle('certificate_received')}
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (file) {
                                                                            if (file.type !== 'application/pdf') { showToast('Only PDFs allowed.'); e.target.value = null; return; }
                                                                            if (file.size > 5 * 1024 * 1024) { showToast('File must be under 5 MB.'); e.target.value = null; return; }
                                                                            handleStageInput('certificate_received', 'file', file);
                                                                        }
                                                                    }}
                                                                />
                                                            ) : (
                                                                /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
                                                                <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                                                    <span className="small text-truncate text-muted fw-bold me-2">
                                                                        <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                                        {editd.certificate_received.file ? editd.certificate_received.file.name : 'EC_Certificate.pdf'}
                                                                    </span>
                                                                    <div className="d-flex gap-2">
                                                                        <Button 
                                                                            variant="outline-primary" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                            onClick={() => {
                                                                                const url = editd.certificate_received.file ? URL.createObjectURL(editd.certificate_received.file) : editd.certificate_received.fileData.url;
                                                                                window.open(url, '_blank');
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-eye me-1"></i> VIEW
                                                                        </Button>
                                                                        <Button 
                                                                            variant="outline-danger" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                            disabled={!canToggle('certificate_received')}
                                                                            onClick={() => {
                                                                                // Clear both state values to completely remove the file
                                                                                handleStageInput('certificate_received', 'file', null);
                                                                                if (editd.certificate_received.fileData) {
                                                                                    handleStageInput('certificate_received', 'fileData', null);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-trash me-1"></i> REMOVE
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )} <br/>
                                                    <Button 
                                                        variant="success"
                                                        size="sm" 
                                                        className="w-100 py-2 fw-bold shadow-sm rounded-pill" 
                                                        onClick={() => handleMsg('EC', { 
                                                        app_no: editonedoc?.application_no, 
                                                        ec_no: `ECA/Online/${editd.certificate_applied?.eca_no || ''}/${new Date().getFullYear()}` 
                                                        })}
                                                    >
                                                        <i className="bi bi-send-check me-2"></i>EC RECEIVED MESSAGE
                                                    </Button>
                                                </motion.div>
                                            )}
                                            </AnimatePresence>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    </Row>
                                    )}
                                </Card.Body>
                                </Card>
                            </motion.div>
                            )}

                            {/* STEP 6: Online Draft / Token */}
                            {currentStep === 6 && (
                            <motion.div key="st6" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                <Card.Header className="bg-white border-0 pt-4 px-4">
                                    <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple, #4a127e)" }}>
                                    Online Draft
                                    </h5>
                                    <p className="text-muted small mb-0">Generate the Temporary Deed (TP) and schedule the registration token.</p>
                                </Card.Header>
                                
                                <Card.Body className="px-4 pb-5">
                                    <Row className="g-4">
                                    
                                    {/* --- TEMPORARY DEED NO --- */}
                                    <Col xs={12} md={status === 'online' ? 12 : 5}>
                                        <div className={`p-4 rounded-3 border h-100 ${editd.deed_no.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            1. Temporary Deed (TP)
                                            </Form.Label>
                                            <ThreeStateToggle 
                                            value={editd.deed_no.values} 
                                            onChange={(val) => handleStageToggleChange('deed_no', val)} 
                                            disabled={!canToggle('deed_no')}
                                            />

                                            <AnimatePresence>
                                            {editd.deed_no.values === 'yes' && (
                                                <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                                <Form.Label className="small fw-bold text-secondary mb-1 text-uppercase">
                                                    TP Number <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control 
                                                    type="text"
                                                    className="shadow-none fw-bold"
                                                    placeholder="Enter TP No. (Ex: 123/2026, 'A')"
                                                    value={editd.deed_no.tp_no || ''}
                                                    disabled={!canToggle('deed_no') || (user?.role === "user" && editd.deed_no.clicked > 0)}
                                                    isInvalid={currentStep === 6 && editd.deed_no.values === 'yes' && !editd.deed_no.tp_no}
                                                    onChange={(e) => {
                                                    const val = e.target.value;
                                                    // RegEx permits alphanumeric characters, spaces, slashes, hyphens, quotes, commas, and dots
                                                    const regex = /^[A-Za-z0-9/\-,\s"' ]*$/;
                                                    if (regex.test(val)) {
                                                        handleStageInput('deed_no', 'tp_no', val);
                                                    }
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    TP Number is required.
                                                </Form.Control.Feedback>
                                                </motion.div>
                                            )}
                                            </AnimatePresence>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* --- TOKEN INITIATED (hidden when Presenceless = Online) --- */}
                                    {status !== 'online' && (
                                    <Col xs={12} md={7}>
                                        <div className={`p-4 rounded-3 border h-100 ${editd.token_initiated.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            2. Token Initiated
                                            </Form.Label>
                                            <ThreeStateToggle 
                                            value={editd.token_initiated.values} 
                                            onChange={(val) => handleStageToggleChange('token_initiated', val)} 
                                            disabled={!canToggle('token_initiated')}
                                            />

                                            <AnimatePresence>
                                            {editd.token_initiated.values === 'yes' && (
                                                <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                                <Row className="g-2 mb-3">
                                                    <Col md={6}>
                                                    <Form.Label className="small fw-bold text-secondary text-uppercase mb-1">
                                                        Token No. <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control 
                                                        type="text"
                                                        className="shadow-none fw-bold"
                                                        placeholder="000"
                                                        value={editd.token_initiated.token_no || ''}
                                                        disabled={!canToggle('token_initiated') || (user?.role === "user" && editd.token_initiated.clicked > 0)}
                                                        isInvalid={currentStep === 6 && editd.token_initiated.values === 'yes' && !editd.token_initiated.token_no}
                                                        onChange={(e) => {
                                                        const val = e.target.value;
                                                        // RegEx validation for clean alphanumeric input strings
                                                        const regex = /^[A-Za-z0-9/\-,\s]*$/;
                                                        if (regex.test(val)) {
                                                            handleStageInput('token_initiated', 'token_no', val);
                                                        }
                                                        }}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Token Number is required.
                                                    </Form.Control.Feedback>
                                                    </Col>
                                                    
                                                    <Col md={6}>
                                                    <Form.Label className="small fw-bold text-secondary text-uppercase mb-1">
                                                        Time Slot
                                                    </Form.Label>
                                                    <Select
                                                        placeholder="Select Time..."
                                                        options={[
                                                        { value: "10 AM - 11 AM", label: "10 AM - 11 AM" }, 
                                                        { value: "11 AM - 12 PM", label: "11 AM - 12 PM" }, 
                                                        { value: "12 PM - 1 PM", label: "12 PM - 1 PM" }, 
                                                        { value: "1 PM - 1:30 PM", label: "1 PM - 1:30 PM" }, 
                                                        { value: "2 PM - 3 PM", label: "2 PM - 3 PM" }, 
                                                        { value: "3 PM - 3:30 PM", label: "3 PM - 3:30 PM" }
                                                        ]}
                                                        styles={selectStyles}
                                                        menuPortalTarget={document.body}
                                                        isDisabled={!canToggle('token_initiated') || (user?.role === "user" && editd.token_initiated.clicked > 0)}
                                                        value={editd.token_initiated.time ? { value: editd.token_initiated.time, label: editd.token_initiated.time } : null}
                                                        onChange={(val) => handleStageInput('token_initiated', 'time', val?.value || '')}
                                                    />
                                                    </Col>
                                                </Row>

                                                {/* --- NEW FILE UPLOAD SECTION --- */}
                                                {isAlreadyCompleted ? (
                                                    <div className="alert alert-secondary py-2 mt-3 small text-center mb-3 border-0 fw-bold">
                                                        <i className="bi bi-shield-check me-2 text-success"></i>Temporary file removed after completion.
                                                    </div>
                                                ) : (
                                                    <div className="mb-3 text-start">
                                                        <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD DOCUMENT (PDF, Max 5MB)</Form.Label>
                                                        
                                                        {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
                                                        {!(editd.token_initiated.file || editd.token_initiated.fileData?.url) ? (
                                                            <Form.Control 
                                                                type="file" accept="application/pdf" size="sm"
                                                                disabled={!canToggle('token_initiated')}
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file) {
                                                                        if (file.type !== 'application/pdf') { showToast('Only PDFs allowed.'); e.target.value = null; return; }
                                                                        if (file.size > 5 * 1024 * 1024) { showToast('File must be under 5 MB.'); e.target.value = null; return; }
                                                                        handleStageInput('token_initiated', 'file', file);
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
                                                            <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                                                <span className="small text-truncate text-muted fw-bold me-2">
                                                                    <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                                    {editd.token_initiated.file ? editd.token_initiated.file.name : 'Token_Document.pdf'}
                                                                </span>
                                                                <div className="d-flex gap-2">
                                                                    <Button 
                                                                        variant="outline-primary" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                        onClick={() => {
                                                                            const url = editd.token_initiated.file ? URL.createObjectURL(editd.token_initiated.file) : editd.token_initiated.fileData.url;
                                                                            window.open(url, '_blank');
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-eye me-1"></i> VIEW
                                                                    </Button>
                                                                    <Button 
                                                                        variant="outline-danger" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                        disabled={!canToggle('token_initiated')}
                                                                        onClick={() => {
                                                                            // Clear both state values to completely remove the file
                                                                            handleStageInput('token_initiated', 'file', null);
                                                                            if (editd.token_initiated.fileData) {
                                                                                handleStageInput('token_initiated', 'fileData', null);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-trash me-1"></i> REMOVE
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="d-flex gap-2">
                                                    <Button 
                                                    className="flex-grow-1 fw-bold py-2 shadow-sm rounded-pill border-0"
                                                    style={{ backgroundColor: 'var(--brand-purple, #8a2be2)', fontSize: '11px' }}
                                                    onClick={() => {
                                                        // 1. Find the full office object using the saved ID
                                                        const selectedOffice = formOffices.find(o => o.id === formData.officeId);
                                                        
                                                        // 2. Extract the name safely and uppercase it
                                                        const officeName = selectedOffice ? selectedOffice.officeName.toUpperCase() : "";

                                                        // 3. Send the payload
                                                        handleMsg('TOKEN', { 
                                                            app_no: editonedoc?.application_no, 
                                                            token: `D-${editd.token_initiated?.token_no || ''}`,
                                                            date: editonedoc?.document_date,
                                                            time: editd.token_initiated?.time,
                                                            office: officeName
                                                        });
                                                    }}
                                                    >
                                                    <i className="bi bi-send-check me-2"></i>TOKEN INITIATED MESSAGE
                                                    </Button>
                                                    <Button 
                                                    variant="outline-warning"
                                                    className="fw-bold py-2 shadow-sm rounded-pill border-2"
                                                    style={{ fontSize: '11px', color: '#4a127e' }}
                                                    onClick={() => {
                                                        // 1. Find the full office object using the saved ID
                                                        const selectedOffice = formOffices.find(o => o.id === formData.officeId);
                                                        
                                                        // 2. Extract the name safely and uppercase it
                                                        const officeName = selectedOffice ? selectedOffice.officeName.toUpperCase() : "";

                                                        // 3. Send the payload
                                                        handleMsg('RM', { 
                                                            app_no: editonedoc?.application_no, 
                                                            token: `D-${editd.token_initiated?.token_no || ''}`,
                                                            date: editonedoc?.document_date,
                                                            time: editd.token_initiated?.time,
                                                            office: officeName
                                                        });
                                                    }}
                                                    >
                                                    <i className="bi bi-bell me-2"></i>REMINDER MESSAGE
                                                    </Button>
                                                </div>
                                                </motion.div>
                                            )}
                                            </AnimatePresence>
                                        </Form.Group>
                                        </div>
                                    </Col>
                                    )}

                                    </Row>
                                </Card.Body>
                                </Card>
                            </motion.div>
                            )}

                            {/* STEP 7: Registration Process */}
                            {currentStep === 7 && (
                            <motion.div key="st7" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                <Card.Header className="bg-white border-0 pt-4 px-4">
                                    <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple, #4a127e)" }}>
                                    Registration Process
                                    </h5>
                                    <p className="text-muted small mb-0">Record stamp inventory and confirm final registration status.</p>
                                </Card.Header>
                                
                                <Card.Body className="px-4 pb-5">
                                    <Row className="g-4">
                                    
                                    {/* --- STAMP PAPER SECTION --- */}
                                    <div className="mb-5">
                                        <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center justify-content-between" style={{ color: '#0dcaf0', fontSize: '0.8rem' }}>
                                            <span className="me-2 flex-shrink-0">Stamp Paper</span>
                                            <hr className="flex-grow-1 my-0 mx-2 opacity-10" />
                                            <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm flex-shrink-0">
                                                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '11px', color: hasStampPaper === 'no' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>No</Typography>
                                                    <AntSwitch
                                                        checked={hasStampPaper === 'yes'}
                                                        disabled={user.role === 'user'}
                                                        onChange={(e) => {
                                                            const next = e.target.checked ? 'yes' : 'no';
                                                            setHasStampPaper(next);
                                                            if (next === 'no') {
                                                                set_Stamp_Paper([{ value: "", number: "" }]);
                                                            }
                                                            if (!up.includes('stamp_Paper')) set_Up(p => [...p, 'stamp_Paper']);
                                                        }}
                                                    />
                                                    <Typography sx={{ fontSize: '11px', color: hasStampPaper === 'yes' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Yes</Typography>
                                                </Stack>
                                            </div>
                                        </h6>

                                        {hasStampPaper === 'yes' && (
                                            <>
                                                {stamp_Paper.map((stamp, idx) => (
                                                    <div key={idx} className="mb-3 p-3 border-start border-4 border-info rounded-end bg-white shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="fw-bold small text-dark">Stamp Paper #{idx + 1}</span>
                                                        {user.role === 'admin' && stamp_Paper.length > 1 && (
                                                        <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => {
                                                            set_Stamp_Paper(p => p.filter((_, i) => i !== idx));
                                                            if (!up.includes('stamp_Paper')) set_Up(p => [...p, 'stamp_Paper']);
                                                        }}>
                                                            <MdClose /> Remove
                                                        </Button>
                                                        )}
                                                    </div>

                                                    <Row className="g-3">
                                                        <Col md={4}>
                                                        <Form.Label className="small fw-bold text-muted">STAMP VALUE (₹)</Form.Label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light border-secondary-subtle">₹</span>
                                                            <Form.Select
                                                            disabled={user.role === 'user'}
                                                            value={stamp.value || ""}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                set_Stamp_Paper(prev => prev.map((item, i) => i === idx ? { ...item, value: val } : item));
                                                                if (!up.includes('stamp_Paper')) set_Up(p => [...p, 'stamp_Paper']);
                                                            }}
                                                            >
                                                            <option value="" disabled>Select Value</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option value="1000">1,000</option>
                                                            <option value="5000">5,000</option>
                                                            <option value="10000">10,000</option>
                                                            <option value="25000">25,000</option>
                                                            </Form.Select>
                                                        </div>
                                                        </Col>
                                                        <Col md={8}>
                                                        <Form.Label className="small fw-bold text-muted">STAMP NUMBER</Form.Label>
                                                        <Form.Control
                                                            disabled={user.role === 'user'}
                                                            placeholder="Ex: AA 123456"
                                                            value={stamp.number || ""}
                                                            isInvalid={currentStep === 7 && !stamp.number?.trim()}
                                                            onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^[A-Za-z0-9\s\-/]*$/.test(val)) {
                                                                set_Stamp_Paper(prev => prev.map((item, i) => i === idx ? { ...item, number: val } : item));
                                                                if (!up.includes('stamp_Paper')) set_Up(p => [...p, 'stamp_Paper']);
                                                            }
                                                            }}
                                                        />
                                                        </Col>
                                                    </Row>
                                                    </div>
                                                ))}

                                                {user.role === 'admin' && (
                                                    <Button 
                                                    variant="outline-info" 
                                                    className="rounded-pill px-3 fw-bold" 
                                                    size="sm" 
                                                    onClick={() => {
                                                        set_Stamp_Paper(p => [...p, { value: '', number: '' }]);
                                                        if (!up.includes('stamp_Paper')) set_Up(p => [...p, 'stamp_Paper']);
                                                    }}
                                                    >
                                                    <MdAdd /> Add Stamp
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                        </div>

                                    {/* --- PAYMENT DETAILS --- */}
                                    <Col xs={12} md={4}>                     
                                        <Form.Group className="p-3 rounded-3 border bg-white h-100 shadow-sm">
                                        <Form.Label className="small fw-bold text-muted text-uppercase mb-2">
                                            Transaction Details
                                        </Form.Label>
                                        <Form.Control 
                                            as="textarea"
                                            rows={2}
                                            name="payment_Info"
                                            className="shadow-none border-0 bg-light"
                                            placeholder="Payment Mode / ID..."
                                            value={editonedoc.payment_Info || ''}
                                            style={{ fontSize: '13px', resize: 'none' }}
                                            isInvalid={currentStep === 7 && !editonedoc.payment_Info}
                                            onChange={(e) => {
                                            const val = e.target.value;
                                            // Allows Letters, Numbers, Spaces, Hyphens, Slashes, and Commas
                                            const regex = /^[A-Za-z0-9\s\-_,.|/]*$/;
                                            if (regex.test(val)) {
                                                handleDataChange(e);
                                            }
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Payment details (Numbers/Letters) are required for Stage 7.
                                        </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    {/* Online: Submitted Message then Final Registration | Offline: Final Registration then Pending */}
                                    {status === 'online' && (
                                    <Col xs={12} md={4}>
                                        <div className="p-3 rounded-3 border h-100 bg-white">
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            Submitted Message
                                            </Form.Label>
                                            <Button 
                                                variant="success"
                                                size="sm" 
                                                className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                                                onClick={() => handleMsg('SUBMITTED')}
                                            >
                                                <i className="bi bi-send-check me-2"></i>SEND SUBMITTED MESSAGE
                                            </Button>
                                        </Form.Group>
                                        </div>
                                    </Col>
                                    )}

                                    {/* --- DOCUMENT REGISTERED --- */}
                                    <Col xs={12} md={4}>
                                        <div className={`p-3 rounded-3 border h-100 ${editd.document_registered.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            Final Registration
                                            </Form.Label>
                                            <ThreeStateToggle 
                                            value={editd.document_registered.values} 
                                            onChange={(val) => handleStageToggleChange('document_registered', val)} 
                                            disabled={!canToggle('document_registered')}
                                            />

                                            <AnimatePresence>
                                            {editd.document_registered.values === 'yes' && (
                                                <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                                <Form.Control 
                                                    className="shadow-none fw-bold mb-2"
                                                    type="text" 
                                                    placeholder="Ex: REG-1234/A_26"
                                                    value={editd.document_registered.document_no || ''} 
                                                    disabled={!canToggle('document_registered')}
                                                    isInvalid={editd.document_registered.values === 'yes' && !editd.document_registered.document_no}
                                                    onChange={(e) => {
                                                    const val = e.target.value;
                                                    // Regex allows: A-Z, a-z, 0-9, forward slash (/), hyphen (-), and underscore (_)
                                                    const regex = /^[A-Za-z0-9/\-_ ]*$/;
                                                    if (regex.test(val)) {
                                                        handleStageInput('document_registered', 'document_no', val);
                                                    }
                                                    }} 
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Registration number is required (Letters, Numbers, / - _).
                                                </Form.Control.Feedback>
                                                <Button 
                                                    variant="success"
                                                    size="sm" 
                                                    className="w-100 fw-bold py-2 mt-2 rounded-pill shadow-sm" 
                                                    onClick={() => handleMsg('REGISTERED', { 
                                                    app_no: editonedoc?.application_no, 
                                                    document_number: `${editd.document_registered?.document_no || ''}/${new Date().getFullYear()}`,
                                                    })}
                                                >
                                                    <i className="bi bi-send-check me-2"></i>REGISTERED MESSAGE
                                                </Button>
                                                </motion.div>
                                            )}
                                            </AnimatePresence>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* --- DOCUMENT PENDING (Offline only) --- */}
                                    {status !== 'online' && (
                                    <Col xs={12} md={4}>
                                        <div className={`p-3 rounded-3 border h-100 ${editd.document_pending.values === 'yes' ? 'bg-danger-subtle border-danger' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            Pending Status
                                            </Form.Label>
                                            <div className="form-check form-switch custom-switch-large mb-2">
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                role="switch"
                                                checked={editd.document_pending.values === 'yes'}
                                                disabled={!canToggle('document_pending')}
                                                onChange={(e) => handleStageToggleChange('document_pending', e.target.checked ? 'yes' : 'no')}
                                            />
                                            <label className={`form-check-label small fw-bold ms-2 ${editd.document_pending.values === 'yes' ? 'text-danger' : 'text-muted'}`}>
                                                {editd.document_pending.values === 'yes' ? "PENDING" : "NORMAL"}
                                            </label>
                                            </div>

                                            <AnimatePresence>
                                            {editd.document_pending.values === 'yes' && (
                                                <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, height: 0 }} className="mt-3 p-2 bg-white rounded-2 border border-danger shadow-sm overflow-hidden">
                                                <Form.Control 
                                                    size="sm"
                                                    className="shadow-none border-0 bg-light fw-bold"
                                                    type="text" 
                                                    placeholder="Pending Doc No." 
                                                    value={editd.document_pending.document_no || ''} 
                                                    disabled={!canToggle('document_pending')}
                                                    isInvalid={editd.document_pending.values === 'yes' && !editd.document_pending.document_no}
                                                    onChange={(e) => {
                                                    const val = e.target.value;
                                                    const regex = /^[A-Za-z0-9/\-_ ]*$/;
                                                    if (regex.test(val)) {
                                                        handleStageInput('document_pending', 'document_no', val);
                                                    }
                                                    }} 
                                                />
                                                <Form.Control.Feedback type="invalid" style={{ fontSize: '10px' }}>
                                                    Pending Doc No. is required.
                                                </Form.Control.Feedback>
                                                <Button 
                                                    variant="warning"
                                                    size="sm" 
                                                    className="w-100 mt-2 fw-bold py-2 rounded-pill shadow-sm border-0 text-white" 
                                                    style={{ backgroundColor: '#f39c12', fontSize: '12px', letterSpacing: '0.5px' }}
                                                    onClick={() => handleMsg('REGISTERED', { 
                                                    app_no: editonedoc?.application_no, 
                                                    document_number: `PENDING/${editd?.document_pending?.document_no}`,
                                                    })}
                                                >
                                                    <i className="bi bi-exclamation-triangle me-2"></i>PENDING MSG
                                                </Button>
                                                </motion.div>
                                            )}
                                            </AnimatePresence>
                                        </Form.Group>
                                        </div>
                                    </Col>
                                    )}

                                    </Row>
                                </Card.Body>
                                </Card>
                            </motion.div>
                            )}

                            {/* STEP 8: Collection */}
                            {currentStep === 8 && (
                                <motion.div key="st8" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                    <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                    <Card.Header className="bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple, #4a127e)" }}>
                                        <i className="bi bi-folder-check me-2"></i>Return Collection
                                        </h5>
                                        <p className="text-muted small mb-0">Finalize the physical handling and digital archival of the document.</p>
                                    </Card.Header>
                                    
                                    <Card.Body className="px-4 pb-5">
                                        <Row className="g-4 py-2">
                                        
                                        {/* --- DOCUMENT COLLECTED (Offline only) --- */}
                                        {status !== 'online' && (
                                        <Col xs={12} md={6}>
                                            <div className={`p-4 rounded-3 border h-100 transition-smooth ${editd.document_collected.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                                            <Form.Group>
                                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                                1. Collection Status
                                                </Form.Label>
                                                <div className="mb-3">
                                                <ThreeStateToggle 
                                                    value={editd.document_collected.values} 
                                                    onChange={(val) => handleStageToggleChange('document_collected', val)} 
                                                    disabled={!canToggle('document_collected')}
                                                />
                                                </div>

                                                <AnimatePresence>
                                                {editd.document_collected.values === 'yes' && (
                                                    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }}>
                                                    <Button 
                                                        variant="primary"
                                                        className="w-100 py-2 fw-bold shadow-sm rounded-pill mt-2" 
                                                        style={{ backgroundColor: 'var(--brand-purple, #4a127e)', border: 'none', fontSize: '12px' }}
                                                        onClick={() => {
    // 1. Find the full office object using the saved ID
    const selectedOffice = formOffices.find(o => o.id === formData.officeId);
    
    // 2. Extract the name safely and uppercase it
    const officeName = selectedOffice ? selectedOffice.officeName.toUpperCase() : "";

    // 3. Send the payload
    handleMsg('COLLECTED', { 
        app_no: editonedoc?.application_no, 
        document_number: `${editd.document_registered?.document_no || ''}/${new Date().getFullYear()}`,
        office: officeName
    });
}}
                                                    >
                                                        <i className="bi bi-mailbox me-2"></i>COLLECTION MESSAGE
                                                    </Button>
                                                    </motion.div>
                                                )}
                                                </AnimatePresence>
                                            </Form.Group>
                                            </div>
                                        </Col>
                                        )}

                                        {/* --- DOCUMENT SCANNED / DOWNLOADED --- */}
                                        <Col xs={12} md={status === 'online' ? 4 : 6}>
                                            <div className={`p-4 rounded-3 border h-100 transition-smooth ${editd.document_scanned.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                            <Form.Group>
                                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                                {status === 'online' ? '1. Downloaded Document' : '2. Scan Status'}
                                                </Form.Label>
                                                <div className="mb-3">
                                                <ThreeStateToggle 
                                                    value={editd.document_scanned.values} 
                                                    onChange={(val) => handleStageToggleChange('document_scanned', val)} 
                                                    disabled={!canToggle('document_scanned')}
                                                />
                                                </div>

                                                <AnimatePresence>
                                                {editd.document_scanned.values === 'yes' && (
                                                    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }}>
                                                    
                                                    {/* --- NEW FILE UPLOAD SECTION (PERMANENT FILE LOGIC) --- */}
                                                    <div className="mb-3 text-start mt-3">
                                                        <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD SCANNED DOC (PDF, Max 10MB)</Form.Label>
                                                        
                                                        {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS (No bypass for completion) */}
                                                        {!(editd.document_scanned.file || editd.document_scanned.fileData?.url) ? (
                                                            <Form.Control 
                                                                type="file" accept="application/pdf" size="sm"
                                                                disabled={!canToggle('document_scanned')}
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file) {
                                                                        if (file.type !== 'application/pdf') { showToast('Only PDFs allowed.'); e.target.value = null; return; }
                                                                        if (file.size > 10 * 1024 * 1024) { showToast('File must be under 10 MB.'); e.target.value = null; return; }
                                                                        handleStageInput('document_scanned', 'file', file);
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
                                                            <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                                                <span className="small text-truncate text-muted fw-bold me-2">
                                                                    <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                                    {editd.document_scanned.file ? editd.document_scanned.file.name : 'Scanned_Document.pdf'}
                                                                </span>
                                                                <div className="d-flex gap-2">
                                                                    <Button 
                                                                        variant="outline-primary" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                        onClick={() => {
                                                                            const url = editd.document_scanned.file ? URL.createObjectURL(editd.document_scanned.file) : editd.document_scanned.fileData.url;
                                                                            window.open(url, '_blank');
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-eye me-1"></i> VIEW
                                                                    </Button>
                                                                    <Button 
                                                                        variant="outline-danger" size="sm" className="fw-bold shadow-sm rounded-pill px-3"
                                                                        disabled={!canToggle('document_scanned')}
                                                                        onClick={() => {
                                                                            // Clear both state values to completely remove the file
                                                                            handleStageInput('document_scanned', 'file', null);
                                                                            if (editd.document_scanned.fileData) {
                                                                                handleStageInput('document_scanned', 'fileData', null);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-trash me-1"></i> REMOVE
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <Button 
                                                        variant="success"
                                                        className="w-100 py-2 fw-bold shadow-sm rounded-pill mt-2" 
                                                        style={{ fontSize: '12px' }}
                                                        onClick={() => handleMsg('SCANNED', { 
                                                        app_no: editonedoc?.application_no, 
                                                        document_number: `${editd.document_registered?.document_no || ''}/${new Date().getFullYear()}`,
                                                        })}
                                                    >
                                                        <i className="bi bi-upc-scan me-2"></i>DOCUMENT SCANNED MESSAGE
                                                    </Button>
                                                    </motion.div>
                                                )}
                                                </AnimatePresence>
                                            </Form.Group>
                                            </div>
                                        </Col>

                                        </Row>
                                    </Card.Body>
                                    </Card>
                                </motion.div>
                            )}

                            {/* STEP 9: Settlement */}
                            {currentStep === 9 && (
                            <motion.div key="st9" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                                <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                <Card.Header className="bg-white border-0 pt-4 px-4">
                                    <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple, #4a127e)" }}>
                                    <i className="bi bi-hand-thumbs-up me-2"></i>Application Completed
                                    </h5>
                                    <p className="text-muted small mb-0">Verify payment completion and record the document recipient.</p>
                                </Card.Header>
                                
                                <Card.Body className="px-4 pb-5">
                                    <Row className="g-4">
                                    
                                    {/* --- DOCUMENT PAYMENT COMPLETED --- */}
                                    <Col xs={12} md={6}>
                                        <div className={`p-4 rounded-3 border h-100 transition-smooth ${editd.payment.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            1. Financial Settlement
                                            </Form.Label>
                                            <div className="mb-3">
                                            <ThreeStateToggle 
                                                value={editd.payment.values} 
                                                onChange={(val) => handleStageToggleChange('payment', val)} 
                                                disabled={!canToggle('payment')}
                                            />
                                            </div>
                                            <div className="d-flex align-items-center mt-3">
                                            <div 
                                                className="rounded-circle me-2" 
                                                style={{ 
                                                width: '10px', height: '10px', 
                                                backgroundColor: editd.payment.values === 'yes' ? '#28a745' : '#dc3545' 
                                                }}
                                            ></div>
                                            <span className="d-inline-flex overflow-hidden align-items-center" style={{ height: '18px' }}>
    <AnimatePresence mode="wait">
        <motion.span
            key={editd.payment.values} /* Triggers the animation on status change */
            initial={{ y: 15, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -15, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fw-bold text-uppercase" 
            style={{ 
                color: editd.payment.values === 'yes' ? '#28a745' : '#dc3545', 
                fontSize: '12px', 
                letterSpacing: '0.5px' 
            }}
        >
            {editd.payment.values === 'yes' ? 'Payment Received' : editd.payment.values === 'no' ? 'Unpaid / Pending' : 'Awaiting Update'}
        </motion.span>
    </AnimatePresence>
</span>
                                            </div>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* --- COLLECTION HANDOVER LOGIC --- */}
                                    <Col xs={12} md={6}>
                                        <div className="p-4 rounded-3 border bg-white h-100 transition-smooth">
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                            2. Document Handover
                                            </Form.Label>
                                            <div className="mb-2">
                                            <ThreeStateToggle 
                                                value={editd.other.values} 
                                                onChange={(val) => handleStageToggleChange('other', val)} 
                                                disabled={!canToggle('other')}
                                            />
                                            </div>
                                            <p className="text-muted mt-3 mb-0" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                            <i className="bi bi-info-circle me-1"></i>
                                            Select <strong>'No'</strong> if a any other represented person by the buyer to collected the document instead of the Buyer.
                                            </p>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* --- OTHER COLLECTOR DETAILS --- */}
                                    <AnimatePresence>
                                        {editd.other.values === 'yes' && (
                                        <motion.div 
                                            initial={{ opacity: 0, y: -20, height: 0 }} 
                                            animate={{ opacity: 1, y: 0, height: 'auto' }} 
                                            exit={{ opacity: 0, y: -20, height: 0 }}
                                            className="col-12 overflow-hidden"
                                        >
                                            <div className="p-4 rounded-3 border-start border-4 border-primary bg-light shadow-sm mt-2">
                                            <h6 className="small fw-bold text-primary text-uppercase mb-4">Recipient Information</h6>
                                            <Row className="g-3">
                                                <Form.Group as={Col} md={4}>
                                                <Form.Label className="small fw-bold text-muted">
                                                    NAME {editd.other?.cusDetail?.cid && <span className="badge bg-primary ms-1">{editd.other.cusDetail.cid}</span>}
                                                </Form.Label>
                                                <CreatableSelect
                                                    isClearable
                                                    value={editd.other?.cusDetail?.name ? { value: editd.other.cusDetail, label: editd.other.cusDetail.name.toUpperCase() } : null}
                                                    options={ooptions || []}
                                                    styles={selectStyles}
                                                    menuPortalTarget={document.body}
                                                    placeholder="Search Recipient..."
                                                    onChange={(val) => handleStageInput('other', 'cusDetail', val?.value || null)}
                                                />
                                                </Form.Group>
                                                <Form.Group as={Col} md={4}>
                                                <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                                                <Form.Control readOnly value={TitleCase(editd.other?.cusDetail?.address || '')} className="bg-white border-0 shadow-none" />
                                                </Form.Group>
                                                <Form.Group as={Col} md={2}>
                                                <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                                                <Form.Control readOnly value={TitleCase(editd.other?.cusDetail?.city || '')} className="bg-white border-0 shadow-none" />
                                                </Form.Group>
                                                <Form.Group as={Col} md={2}>
                                                <Form.Label className="small fw-bold text-muted">MOBILE</Form.Label>
                                                <Form.Control readOnly value={editd.other?.cusDetail?.mobile || ''} className="bg-white border-0 shadow-none" />
                                                </Form.Group>
                                            </Row>
                                            </div>
                                        </motion.div>
                                        )}
                                    </AnimatePresence>

                                    {/* --- FINAL ACTION --- */}
                                    {/* --- NEW TEXT FIELDS & FINAL ACTION --- */}
<Col xs={12} className="pt-4 border-top">
    
    <Row className="g-4 mb-4 text-start">
        <Col md={6}>
            <Form.Group>
                <Form.Label className="small fw-bold text-muted text-uppercase mb-2">Remarks</Form.Label>
                <Form.Control 
                    as="textarea" 
                    rows={5} 
                    name="remarks"
                    className="shadow-none border-secondary-subtle bg-light"
                    placeholder="Enter any final remarks..."
                    value={editonedoc.remarks || ''} 
                    onChange={handleDataChange}
                    disabled={user.role === 'user'} // Optional: Lock for standard users if needed
                />
            </Form.Group>
        </Col>
        
        <Col md={6}>
            <Form.Group>
                <Form.Label className="small fw-bold text-muted text-uppercase mb-2">Internal Notes</Form.Label>
                <Form.Control 
                    as="textarea" 
                    rows={5} 
                    name="internal_notes"
                    className="shadow-none border-secondary-subtle bg-white"
                    placeholder="Enter private internal notes here..."
                    value={editonedoc.internal_notes || ''} 
                    onChange={handleDataChange}
                    disabled={user.role === 'user'} // Optional: Lock for standard users if needed
                />
            </Form.Group>
        </Col>
    </Row>

    <div className="text-center">
        <div className="mb-3 small text-muted px-md-5">
            Once you send the final message, the application process is officially marked as complete in the system records.
        </div>
        <Button 
            size="lg"
            className="px-5 py-3 fw-bold shadow rounded-pill border-0"
            style={{ backgroundColor: 'var(--brand-purple, #4a127e)', transition: 'transform 0.2s' }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.03)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            onClick={() => handleMsg('THANK', { 
                app_no: editonedoc?.application_no, 
                document_number: `${editd.document_registered?.document_no || ''}/${new Date().getFullYear()}` 
            })}
        >
            <i className="bi bi-stars me-2"></i>SEND THANK YOU MESSAGE
        </Button>
    </div>
</Col>

                                    </Row>
                                </Card.Body>
                                </Card>
                            </motion.div>
                            )}
                        </AnimatePresence>

                        {/* STEPPER NAVIGATION */}
                        <div className="d-flex justify-content-between mt-5 mb-5">
                            <Button type="button" variant="secondary" onClick={() =>{
                                if (!validateCurrentStep(currentStep)) return; // Stops here, toast is triggered inside the function
                                    setCurrentStep(p => getAdjacentStep(p, -1))
                                }} disabled={currentStep === 1} className="d-flex align-items-center gap-1">
                                <MdChevronLeft /> Back
                            </Button>
                            <div className="d-flex gap-2">
                                {currentStep < 9 ? (<>
                                    <Button 
                                        type="button" 
                                        style={{ backgroundColor: '#8a2be2', borderColor: '#8a2be2', color: 'white' }} 
                                        onClick={(e) => { 
                                            e.preventDefault(); 
                                            
                                            if (validateCurrentStep(currentStep)) { 
                                                setCurrentStep(p => getAdjacentStep(p, 1)); 
                                                window.scrollTo(0,0); 
                                            }
                                        }} 
                                        className="d-flex align-items-center gap-1 px-4"
                                    >
                                        Next Step <MdChevronRight />
                                    </Button>
                                    <Button type="submit" variant="success" disabled={bt} className="px-5 fw-bold shadow-sm">
                                        {bt ? 'Saving...' : 'Save Changes'}
                                    </Button></>
                                ) : (
                                    <Button type="submit" variant="success" disabled={bt} className="px-5 fw-bold shadow-sm">
                                        {bt ? 'Saving...' : 'Save Changes'}
                                    </Button>
                                )}
                            </div>
                        </div>

                    </Form>
                )}
            </SimpleBar>

            <AnimatePresence>
                {add && (
                    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="modal-overlay-wrapper">
                        <AddClient setAdd={setAdd} showToast={showToast} get_customer={fetchClients} />
                    </motion.div>
                )}
                {msg && (
                    <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} style={{ position: 'fixed', bottom: '40px', left: '0', right: '0', zIndex: 3000, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
                        <div style={{ pointerEvents: 'auto' }}><CopyMsg set_msg={set_msg} content={activeMsgText} /></div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};